import { gql } from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

/** for now only 'user', but later we may need to add other data when returning */
export type AuthResponse = {
  __typename?: 'AuthResponse';
  user?: Maybe<XUser>;
};

/**
 * Collection = 'evmcgill_db.redirects_brokers' - site associated to each broker, used to
 * dynamically build 'redirects_listings' collection w/ each MLS ID associated to its broker's site
 */
export type BrokerRedirect = {
  __typename?: 'BrokerRedirect';
  /** broker id (Centris code) */
  id?: Maybe<Scalars['String']['output']>;
  /** domain only of the site where to redirect this broker's listings from Centris */
  site?: Maybe<Scalars['String']['output']>;
};

export type BrokerRedirectInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Scalars['String']['input']>;
};

export type CtrAddenda = {
  __typename?: 'CtrAddenda';
  /** Previously IND_INTERNET */
  CHAMP_INUTILISE_1?: Maybe<Scalars['String']['output']>;
  /** Previously IND_SIA */
  CHAMP_INUTILISE_2?: Maybe<Scalars['String']['output']>;
  /** Indicates language code, please refer to the VALEURS_FIXES table */
  CODE_LANGUE?: Maybe<Scalars['String']['output']>;
  /** Addendum number, 1 if there is only one */
  NO_ADDENDA?: Maybe<Scalars['String']['output']>;
  /** Listing no */
  NO_INSCRIPTION?: Maybe<Scalars['String']['output']>;
  /** Addendum display order */
  ORDRE_AFFICHAGE?: Maybe<Scalars['String']['output']>;
  /** 60-character text field used to enter text of addendum */
  TEXTE?: Maybe<Scalars['String']['output']>;
};

export type CtrBureaux = {
  __typename?: 'CtrBureaux';
  /** Office address number (cont'd) */
  BUREAU?: Maybe<Scalars['String']['output']>;
  /** Office code */
  CODE?: Maybe<Scalars['String']['output']>;
  /** Office postal code */
  CODE_POSTAL?: Maybe<Scalars['String']['output']>;
  /** E-mail address */
  COURRIEL?: Maybe<Scalars['String']['output']>;
  /** Office manager member code */
  DIRECTEUR_CODE?: Maybe<Scalars['String']['output']>;
  /** Firm code */
  FIRME_CODE?: Maybe<Scalars['String']['output']>;
  /** City name where office is located */
  MUNICIPALITE?: Maybe<Scalars['String']['output']>;
  /** Office legal name */
  NOM_LEGAL?: Maybe<Scalars['String']['output']>;
  /** Street name where office is located */
  NOM_RUE?: Maybe<Scalars['String']['output']>;
  /** Office civic number */
  NO_CIVIQUE?: Maybe<Scalars['String']['output']>;
  /** Phone extension for phone 1 */
  POSTE_1?: Maybe<Scalars['String']['output']>;
  /** Phone extension for phone 2 */
  POSTE_2?: Maybe<Scalars['String']['output']>;
  /** Province code */
  PROVINCE?: Maybe<Scalars['String']['output']>;
  /** Office Internet address */
  SITE_WEB?: Maybe<Scalars['String']['output']>;
  /** Main phone number */
  TELEPHONE_1?: Maybe<Scalars['String']['output']>;
  /** Secondary phone number */
  TELEPHONE_2?: Maybe<Scalars['String']['output']>;
  /** Office fax number */
  TELEPHONE_FAX?: Maybe<Scalars['String']['output']>;
  /** URL to download the office logo */
  URL_LOGO_BUREAU?: Maybe<Scalars['String']['output']>;
};

/** Main types of characteristics as provided in static table TYPE_CARACTERISTIQUES */
export enum CtrCaracTypes {
  /** Abri d'auto / Carport */
  Abri = 'ABRI',
  /** Adapté pour personnes à mobilité réduite / Mobility impaired accessible */
  Adap = 'ADAP',
  /** Allée / Driveway */
  Alle = 'ALLE',
  /** Aménagement du terrain / Landscaping */
  Amen = 'AMEN',
  /** Type d'animaux / Animal types */
  Anim = 'ANIM',
  /** Armoires / Cupboard */
  Armo = 'ARMO',
  /** Base de sous-sol / Basement foundation */
  Bass = 'BASS',
  /** Batiment / Building */
  Bati = 'BATI',
  /** Mode de chauffage / Heating system */
  Chau = 'CHAU',
  /** Approvisionnement en eau / Water supply */
  Eau = 'EAU',
  /** Efficacité énergétique / Energy efficiency */
  Effn = 'EFFN',
  /** Énergie pour le chauffage / Heating energy */
  Ener = 'ENER',
  /** Équipement disponible / Equipment available */
  Equi = 'EQUI',
  /** Exploitation / Exploitation */
  Expl = 'EXPL',
  /** Facilité d'accès / Easy access */
  Facc = 'FACC',
  /** Fenêtres / Windows */
  Fene = 'FENE',
  /** Fondation / Foundation */
  Fond = 'FOND',
  /** Foyers-poêles / Hearth stove */
  Fopo = 'FOPO',
  /** Garage / Garage */
  Gara = 'GARA',
  /** Genre de commerce / Kind of commerce */
  Gcom = 'GCOM',
  /** Appareils en location / Rental appliances */
  Loc = 'LOC',
  /** Machinerie / Equipment */
  Mach = 'MACH',
  /** Revêtements / Siding */
  Pare = 'PARE',
  /** Particularités / Distinctive features */
  Part = 'PART',
  /** Piscine / Pool */
  Pisc = 'PISC',
  /** Proximité / Proximity */
  Prox = 'PROX',
  /** Restrictions/Permissions / Restrictions/Permissions */
  Repe = 'REPE',
  /** Salle de bains/salle d'eau / Bathroom / Washroom */
  Sdb = 'SDB',
  /** Services disponibles / Available services */
  Sdis = 'SDIS',
  /** Sous-sol / Basement */
  Ss = 'SS',
  /** Stationnement cadastré (inclus dans le prix) / Cadastre - Parking (included in the price) */
  Stac = 'STAC',
  /** Option de stationnement en location / Option of leased parking */
  Stao = 'STAO',
  /** Stationnement (total) / Parking (total) */
  Stat = 'STAT',
  /** Stationnement cadastré (exclus du prix) / Cadastre - Parking (excluded in the price) */
  Stax = 'STAX',
  /** Système d'égouts / Sewage system */
  Syeg = 'SYEG',
  /** Type de commerce/Industrie / Type of business/Industry */
  Tcom = 'TCOM',
  /** Type de fenêtre / Window type */
  Tfen = 'TFEN',
  /** Toiture / Roofing */
  Toit = 'TOIT',
  /** Topographie / Topography */
  Topo = 'TOPO',
  /** Vue / View */
  Vue = 'VUE',
  /** Zonage / Zoning */
  Zong = 'ZONG'
}

export type CtrCaracteristiques = {
  __typename?: 'CtrCaracteristiques';
  /** Additional information (in English) about a specific feature */
  INFORMATIONS_ANGLAISES?: Maybe<Scalars['String']['output']>;
  /** Additional information (in French) about a specific feature */
  INFORMATIONS_FRANCAISES?: Maybe<Scalars['String']['output']>;
  /** Amount ($) related to the feature */
  MONTANT?: Maybe<Scalars['String']['output']>;
  /** Number of items in response to type of feature (optional) */
  NOMBRE?: Maybe<Scalars['String']['output']>;
  /** Listing no */
  NO_INSCRIPTION?: Maybe<Scalars['String']['output']>;
  /** A special feature of the property in response to type of feature */
  SCARAC_CODE?: Maybe<Scalars['String']['output']>;
  /** Type of feature code */
  TCAR_CODE?: Maybe<Scalars['String']['output']>;
};

export type CtrDepenses = {
  __typename?: 'CtrDepenses';
  /** Year of expense appraisal */
  ANNEE?: Maybe<Scalars['String']['output']>;
  /** Expiry year of expense (ex.: for area taxes) */
  ANNEE_EXPIRATION?: Maybe<Scalars['String']['output']>;
  /** English description for other expenses */
  AU_DEPENSE_INFO_A?: Maybe<Scalars['String']['output']>;
  /** French description for other expenses */
  AU_DEPENSE_INFO_F?: Maybe<Scalars['String']['output']>;
  /** Indicates it consists of an annual or a monthly expense */
  FREQUENCE?: Maybe<Scalars['String']['output']>;
  /** Annual amount of expense (within about a dollar) */
  MONTANT_DEPENSE?: Maybe<Scalars['String']['output']>;
  /** Listing no */
  NO_INSCRIPTION?: Maybe<Scalars['String']['output']>;
  /** Expense feature: general, for the building or the business */
  PART_DEPENSE?: Maybe<Scalars['String']['output']>;
  /** Type of expense: municipal taxes, area taxes, energy cost, rental devices cost, condominium fees, etc. */
  TDEP_CODE?: Maybe<Scalars['String']['output']>;
};

/** Domains in VALEURS_FIXES used for grouping certain types of data */
export enum CtrDomainsVf {
  CategoriePropriete = 'CATEGORIE_PROPRIETE',
  CodeAnneeConstruction = 'CODE_ANNEE_CONSTRUCTION',
  CodeDeclarationVendeur = 'CODE_DECLARATION_VENDEUR',
  CodeDescriptionPhoto = 'CODE_DESCRIPTION_PHOTO',
  CodeLangue = 'CODE_LANGUE',
  CodeStatut = 'CODE_STATUT',
  CodeVisiteCaravane = 'CODE_VISITE_CARAVANE',
  CouvrePlancherCode = 'COUVRE_PLANCHER_CODE',
  Etage = 'ETAGE',
  FrequenceDepense = 'FREQUENCE_DEPENSE',
  FrequencePrixLocation = 'FREQUENCE_PRIX_LOCATION',
  IndRepriseFinance = 'IND_REPRISE_FINANCE',
  IndVenteSansGarantieLegale = 'IND_VENTE_SANS_GARANTIE_LEGALE',
  Niveau = 'NIVEAU',
  ParticulariteConstruction = 'PARTICULARITE_CONSTRUCTION',
  PartDepense = 'PART_DEPENSE',
  PieceCode = 'PIECE_CODE',
  RenovationType = 'RENOVATION_TYPE',
  TypeBatiment = 'TYPE_BATIMENT',
  TypeCertificatFirme = 'TYPE_CERTIFICAT_FIRME',
  TypeCertificatMembre = 'TYPE_CERTIFICAT_MEMBRE',
  TypeCopropriete = 'TYPE_COPROPRIETE',
  TypeDepense = 'TYPE_DEPENSE',
  TypeDivulInteret = 'TYPE_DIVUL_INTERET',
  TypeLien = 'TYPE_LIEN',
  TypeMediaSocial = 'TYPE_MEDIA_SOCIAL',
  TypeSuperficieHabitable = 'TYPE_SUPERFICIE_HABITABLE',
  TypeUniteDet = 'TYPE_UNITE_DET',
  TypeUniteSom = 'TYPE_UNITE_SOM',
  UmAireBatiment = 'UM_AIRE_BATIMENT',
  UmDimensionBatiment = 'UM_DIMENSION_BATIMENT',
  UmDimensionTerrain = 'UM_DIMENSION_TERRAIN',
  UmHauteurLibre = 'UM_HAUTEUR_LIBRE',
  UmLoyerMensuelUnitaire = 'UM_LOYER_MENSUEL_UNITAIRE',
  UmPrix = 'UM_PRIX',
  UmSuperficieTerrain = 'UM_SUPERFICIE_TERRAIN',
  UmSuperficieTotale = 'UM_SUPERFICIE_TOTALE',
  UmSuperficieVacante = 'UM_SUPERFICIE_VACANTE',
  UtilisationCommerciale = 'UTILISATION_COMMERCIALE'
}

/** input vars to override any field in dynamic tables; the custom values are stored in override_<table> */
export type CtrDynamicCustomInput = {
  custom_kvs?: InputMaybe<Array<InputMaybe<CtrDynamicCustomKeyVal>>>;
  filter_keys: Array<InputMaybe<Scalars['String']['input']>>;
  filter_vals: Array<InputMaybe<Scalars['String']['input']>>;
  table: Scalars['String']['input'];
};

/** single instance of key:val for overriding original values in some dynamic table (e.g. MEMBRES) */
export type CtrDynamicCustomKeyVal = {
  custom_key?: InputMaybe<Scalars['String']['input']>;
  custom_value?: InputMaybe<Scalars['String']['input']>;
};

/** Dynamic Centris MLS tables (from meta_tables) */
export enum CtrDynamicTables {
  Addenda = 'ADDENDA',
  Bureaux = 'BUREAUX',
  Caracteristiques = 'CARACTERISTIQUES',
  Depenses = 'DEPENSES',
  Firmes = 'FIRMES',
  Inscriptions = 'INSCRIPTIONS',
  LiensAdditionnels = 'LIENS_ADDITIONNELS',
  Membres = 'MEMBRES',
  MembresMediasSociaux = 'MEMBRES_MEDIAS_SOCIAUX',
  Photos = 'PHOTOS',
  PiecesUnites = 'PIECES_UNITES',
  Remarques = 'REMARQUES',
  Renovations = 'RENOVATIONS',
  UnitesDetaillees = 'UNITES_DETAILLEES',
  UnitesSommaires = 'UNITES_SOMMAIRES',
  VisitesLibres = 'VISITES_LIBRES'
}

export type CtrDynamicUniqueKeys = {
  __typename?: 'CtrDynamicUniqueKeys';
  ADDENDA?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BUREAUX?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CARACTERISTIQUES?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  DEPENSES?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  FIRMES?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  INSCRIPTIONS?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  LIENS_ADDITIONNELS?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  MEMBRES?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  MEMBRES_MEDIAS_SOCIAUX?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PHOTOS?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PIECES_UNITES?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  REMARQUES?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RENOVATIONS?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  UNITES_DETAILLEES?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  UNITES_SOMMAIRES?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  VISITES_LIBRES?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CtrFirmes = {
  __typename?: 'CtrFirmes';
  /** Code indicating which banner owns the firm */
  BANNIERE_CODE?: Maybe<Scalars['String']['output']>;
  /** Firm code */
  CODE?: Maybe<Scalars['String']['output']>;
  /** Main firm's agency executive officer member code */
  COURTIER_CODE?: Maybe<Scalars['String']['output']>;
  /** Main firm's code for brokerage firms with a franchise */
  FIRME_PRINCIPALE?: Maybe<Scalars['String']['output']>;
  /** Firm legal name */
  NOM_LEGAL?: Maybe<Scalars['String']['output']>;
  /** Brokerage firm's licence number awarded by OACIQ */
  NO_CERTIFICAT?: Maybe<Scalars['String']['output']>;
  /** Type of licence */
  TYPE_CERTIFICAT?: Maybe<Scalars['String']['output']>;
};

export type CtrGenresProprietes = {
  __typename?: 'CtrGenresProprietes';
  /** Property classification based on the following categories: residential, plex, land/lot area, revenue property, commercial, industrial, farming */
  CATEGORIE_PROPRIETE?: Maybe<Scalars['String']['output']>;
  CUSTOM_EN?: Maybe<Scalars['String']['output']>;
  CUSTOM_FR?: Maybe<Scalars['String']['output']>;
  /** English summary description of property type */
  DESCRIPTION_ABREGEE_ANGLAISE?: Maybe<Scalars['String']['output']>;
  /** French summary description of property type */
  DESCRIPTION_ABREGEE_FRANCAISE?: Maybe<Scalars['String']['output']>;
  /** English description of property type */
  DESCRIPTION_ANGLAISE?: Maybe<Scalars['String']['output']>;
  /** French description of property type */
  DESCRIPTION_FRANCAISE?: Maybe<Scalars['String']['output']>;
  /** Ex: bungalow */
  GENRE_PROPRIETE?: Maybe<Scalars['String']['output']>;
};

export type CtrInscriptions = {
  __typename?: 'CtrInscriptions';
  /** Full english addenda ( 3000 car. + carriage return) */
  ADDENDA_COMPLET_A?: Maybe<Scalars['String']['output']>;
  /** Full french addenda ( 3000 car. + carriage return) */
  ADDENDA_COMPLET_F?: Maybe<Scalars['String']['output']>;
  /** Year of construction */
  ANNEE_CONTRUCTION?: Maybe<Scalars['String']['output']>;
  /** Appraisal year of lot area and building */
  ANNEE_EVALUATION?: Maybe<Scalars['String']['output']>;
  /** Indicates lease expiry month and year */
  ANNEE_MOIS_ECHEANCE_BAIL?: Maybe<Scalars['String']['output']>;
  /** Apartment or unit number */
  APPARTEMENT?: Maybe<Scalars['String']['output']>;
  /** English description for other property type */
  AU_GENRE_PROPRIETE_INFO_A?: Maybe<Scalars['String']['output']>;
  /** French description for other property type */
  AU_GENRE_PROPRIETE_INFO_F?: Maybe<Scalars['String']['output']>;
  /** office code 1 */
  BUREAU_INSCRIPTEUR_1?: Maybe<Scalars['String']['output']>;
  /** office code 2 */
  BUREAU_INSCRIPTEUR_2?: Maybe<Scalars['String']['output']>;
  /** Office code 3 */
  BUREAU_INSCRIPTEUR_3?: Maybe<Scalars['String']['output']>;
  /** Office code4 */
  BUREAU_INSCRIPTEUR_4?: Maybe<Scalars['String']['output']>;
  /** Property classification based on the following categories: residential, plex, land/lot area, revenue, commercial, industrial, farming property */
  CATEGORIE_PROPRIETE?: Maybe<Scalars['String']['output']>;
  /** Previously CODE_LANGUE_INSCRIPTION */
  CHAMP_INUTILISE_1?: Maybe<Scalars['String']['output']>;
  /** This field is not used at the moment */
  CHAMP_INUTILISE_2?: Maybe<Scalars['String']['output']>;
  /** Previously RETRIBUTION_VENDEUR */
  CHAMP_INUTILISE_3?: Maybe<Scalars['String']['output']>;
  /** Previously GENRE_RETRIBUTION */
  CHAMP_INUTILISE_4?: Maybe<Scalars['String']['output']>;
  /** Previously NOM_PROPRIETAIRE_1 */
  CHAMP_INUTILISE_5?: Maybe<Scalars['String']['output']>;
  /** Previously ADRESSE_PROPRIETAIRE_1 */
  CHAMP_INUTILISE_6?: Maybe<Scalars['String']['output']>;
  /** Previously TEL1_PROPRIETAIRE_1 */
  CHAMP_INUTILISE_7?: Maybe<Scalars['String']['output']>;
  /** Previously TEL2_PROPRIETAIRE_1 */
  CHAMP_INUTILISE_8?: Maybe<Scalars['String']['output']>;
  /** Previously POSTE_TEL2_PROPRIETAIRE_1 */
  CHAMP_INUTILISE_9?: Maybe<Scalars['String']['output']>;
  /** Previously NOM_PROPRIETAIRE_2 */
  CHAMP_INUTILISE_10?: Maybe<Scalars['String']['output']>;
  /** ADRESSE_PROPRIETAIRE_2 */
  CHAMP_INUTILISE_11?: Maybe<Scalars['String']['output']>;
  /** Previously TEL1_PROPRIETAIRE_2 */
  CHAMP_INUTILISE_12?: Maybe<Scalars['String']['output']>;
  /** Previously TEL2_PROPRIETAIRE_2 */
  CHAMP_INUTILISE_13?: Maybe<Scalars['String']['output']>;
  /** Previously POSTE_TEL2_PROPRIETAIRE_2 */
  CHAMP_INUTILISE_14?: Maybe<Scalars['String']['output']>;
  /** Previously INFO_RENDEZ_VOUS */
  CHAMP_INUTILISE_15?: Maybe<Scalars['String']['output']>;
  /** Previously DIMENSION_BATIMENT */
  CHAMP_INUTILISE_16?: Maybe<Scalars['String']['output']>;
  /** Previously DIMENSION_TERRAIN */
  CHAMP_INUTILISE_17?: Maybe<Scalars['String']['output']>;
  /** Previously REVENUS_LOCATION_AN_POTENTIELS */
  CHAMP_INUTILISE_18?: Maybe<Scalars['String']['output']>;
  /** Previously AUTRES_REVENUS_BRUT */
  CHAMP_INUTILISE_19?: Maybe<Scalars['String']['output']>;
  /** Previously REVENUS_AN_POTENTIELS */
  CHAMP_INUTILISE_20?: Maybe<Scalars['String']['output']>;
  /** Previously PERTE_VACANCES_MAUV_CREANCES */
  CHAMP_INUTILISE_21?: Maybe<Scalars['String']['output']>;
  /** Previously REVENUS_AN_NET_AVANT_SERV_DETTE */
  CHAMP_INUTILISE_22?: Maybe<Scalars['String']['output']>;
  /** Previously SERVICE_DETTE */
  CHAMP_INUTILISE_23?: Maybe<Scalars['String']['output']>;
  /** FACADE_PLAN_EAU */
  CHAMP_INUTILISE_24?: Maybe<Scalars['String']['output']>;
  /** NB_CHAUFFE_EAU_TOTAL */
  CHAMP_INUTILISE_25?: Maybe<Scalars['String']['output']>;
  /** CODE_NB_UNITES_TOTAL */
  CHAMP_INUTILISE_26?: Maybe<Scalars['String']['output']>;
  /** IND_PLAN_ARPENTAGE */
  CHAMP_INUTILISE_27?: Maybe<Scalars['String']['output']>;
  /** ANNEE_PLAN_ARPENTAGE */
  CHAMP_INUTILISE_28?: Maybe<Scalars['String']['output']>;
  /** IND_TITRE_PROPRIETE */
  CHAMP_INUTILISE_29?: Maybe<Scalars['String']['output']>;
  /** NOTE_TAXE */
  CHAMP_INUTILISE_30?: Maybe<Scalars['String']['output']>;
  /** NO_CASIER */
  CHAMP_INUTILISE_31?: Maybe<Scalars['String']['output']>;
  /** NO_STATIONNEMENT */
  CHAMP_INUTILISE_32?: Maybe<Scalars['String']['output']>;
  /** Previously DESC_GENRE_ENTR */
  CHAMP_INUTILISE_33?: Maybe<Scalars['String']['output']>;
  /** Previously TYPE_BAIL */
  CHAMP_INUTILISE_34?: Maybe<Scalars['String']['output']>;
  /** Previously GENRE_BAIL */
  CHAMP_INUTILISE_35?: Maybe<Scalars['String']['output']>;
  /** Previously IND_CLAUSE_RESTRICTIVE */
  CHAMP_INUTILISE_36?: Maybe<Scalars['String']['output']>;
  /** Previously CLEF */
  CHAMP_INUTILISE_37?: Maybe<Scalars['String']['output']>;
  /** Previously DATE_EXPIRATION */
  CHAMP_INUTILISE_38?: Maybe<Scalars['String']['output']>;
  /** Previously CADASTRE */
  CHAMP_INUTILISE_39?: Maybe<Scalars['String']['output']>;
  /** Previously IND_CERTIFICAT_LOCALISATION */
  CHAMP_INUTILISE_40?: Maybe<Scalars['String']['output']>;
  /** Previously ANNEE_CERTIFICAT_LOCALISATION */
  CHAMP_INUTILISE_41?: Maybe<Scalars['String']['output']>;
  /** Previously DATE_ACTE_VENTE */
  CHAMP_INUTILISE_42?: Maybe<Scalars['String']['output']>;
  /** Previously DELAI_ACTE_VENTE_FRANCAIS */
  CHAMP_INUTILISE_43?: Maybe<Scalars['String']['output']>;
  /** Previously DELAI_ACTE_VENTE_ANGLAIS */
  CHAMP_INUTILISE_44?: Maybe<Scalars['String']['output']>;
  /** Previously CODE_RENDEZ_VOUS */
  CHAMP_INUTILISE_45?: Maybe<Scalars['String']['output']>;
  /** Previously MATRICULE */
  CHAMP_INUTILISE_46?: Maybe<Scalars['String']['output']>;
  /** Previously NOM_FICHIER_PHOTO */
  CHAMP_INUTILISE_47?: Maybe<Scalars['String']['output']>;
  /** Previously NO_CONTRAT_COURTAGE */
  CHAMP_INUTILISE_48?: Maybe<Scalars['String']['output']>;
  /** Previously IND_ADRESSE_SUR_INTERNET */
  CHAMP_INUTILISE_49?: Maybe<Scalars['String']['output']>;
  /** Previously DATE_PROMESSE_ACHAT_COND */
  CHAMP_INUTILISE_50?: Maybe<Scalars['String']['output']>;
  /** Previously IND_PROMESSE_ACHAT_COND */
  CHAMP_INUTILISE_51?: Maybe<Scalars['String']['output']>;
  /** Previously TEL_RENDEZ_VOUS */
  CHAMP_INUTILISE_52?: Maybe<Scalars['String']['output']>;
  /** Code indicating if year of construction of building is historical, under construction, aged, approximate or unknown */
  CODE_ANNEE_CONSTRUCTION?: Maybe<Scalars['String']['output']>;
  /** Indicates nature of seller's declaration */
  CODE_DECLARATION_VENDEUR?: Maybe<Scalars['String']['output']>;
  /** Postal code */
  CODE_POSTAL?: Maybe<Scalars['String']['output']>;
  /** Indicates listing status, please refer to valeurs_fixes table for possible values */
  CODE_STATUT?: Maybe<Scalars['String']['output']>;
  /** Indicates if the broker 1 has a direct or indirect interest in the property. See the table "VALEURS_FIXES" for the possible values */
  COURTIER1_TYPE_DIVUL_INTERET?: Maybe<Scalars['String']['output']>;
  /** Indicates if the broker 2 has a direct or indirect interest in the property. See the table "VALEURS_FIXES" for the possible values */
  COURTIER2_TYPE_DIVUL_INTERET?: Maybe<Scalars['String']['output']>;
  /** Indicates if the broker 3 has a direct or indirect interest in the property. See the table "VALEURS_FIXES" for the possible values */
  COURTIER3_TYPE_DIVUL_INTERET?: Maybe<Scalars['String']['output']>;
  /** Indicates if the broker 4 has a direct or indirect interest in the property. See the table "VALEURS_FIXES" for the possible values */
  COURTIER4_TYPE_DIVUL_INTERET?: Maybe<Scalars['String']['output']>;
  /** Listing broker code 1 */
  COURTIER_INSCRIPTEUR_1?: Maybe<Scalars['String']['output']>;
  /** Listing broker code 2 */
  COURTIER_INSCRIPTEUR_2?: Maybe<Scalars['String']['output']>;
  /** Listing broker code 3 */
  COURTIER_INSCRIPTEUR_3?: Maybe<Scalars['String']['output']>;
  /** Listing broker code 4 */
  COURTIER_INSCRIPTEUR_4?: Maybe<Scalars['String']['output']>;
  /** End of lease date */
  DATE_FIN_BAIL?: Maybe<Scalars['String']['output']>;
  /** Date when the listing became active for the first time */
  DATE_MISE_EN_VIGUEUR?: Maybe<Scalars['String']['output']>;
  /** Indicates date and time of listing addition or last listing edit */
  DATE_MODIF?: Maybe<Scalars['String']['output']>;
  /** The date by which occupancy will take place */
  DATE_OCCUPATION?: Maybe<Scalars['String']['output']>;
  /** Reference date for gross revenues */
  DATE_REV_BRUT_POT?: Maybe<Scalars['String']['output']>;
  /** The deadline by which occupancy will take place (in English) */
  DELAI_OCCUPATION_ANGLAIS?: Maybe<Scalars['String']['output']>;
  /** The deadline by which occupancy will take place (in French) */
  DELAI_OCCUPATION_FRANCAIS?: Maybe<Scalars['String']['output']>;
  /** Total annual operation expenses */
  DEPENSES_TOT_EXPLOITATION?: Maybe<Scalars['String']['output']>;
  /** Canadian dollar */
  DEVISE_PRIX_DEMANDE?: Maybe<Scalars['String']['output']>;
  /** Canadian dollar */
  DEVISE_PRIX_LOCATION_DEMANDE?: Maybe<Scalars['String']['output']>;
  /** Indicates since when business is operational */
  EN_OPER_DEPUIS?: Maybe<Scalars['String']['output']>;
  /** Building appraisal amount */
  EVALUATION_MUNICIPALE_BATIMENT?: Maybe<Scalars['String']['output']>;
  /** Lot area appraisal amount */
  EVALUATION_MUNICIPALE_TERRAIN?: Maybe<Scalars['String']['output']>;
  /** English description of excluded items in sale 500 car. */
  EXCLUS_ANGLAIS?: Maybe<Scalars['String']['output']>;
  /** French description of excluded items in sale 500 car. */
  EXCLUS_FRANCAIS?: Maybe<Scalars['String']['output']>;
  /** Dimensions of building facade.  If property type is commercial or condominium and condominium type is divided, then it represents the private portion or share area */
  FACADE_BATIMENT?: Maybe<Scalars['String']['output']>;
  /** Dimensions of lot area facade */
  FACADE_TERRAIN?: Maybe<Scalars['String']['output']>;
  /** Indicates rental price frequency, please refer to valeurs_fixes table for possible values */
  FREQUENCE_PRIX_LOCATION?: Maybe<Scalars['String']['output']>;
  /** ex. bungalow */
  GENRE_PROPRIETE?: Maybe<Scalars['String']['output']>;
  /** English description of included items in sale 500 car. */
  INCLUS_ANGLAIS?: Maybe<Scalars['String']['output']>;
  /** French description of included items in sale 500 car. */
  INCLUS_FRANCAIS?: Maybe<Scalars['String']['output']>;
  /** Indicates if owner would like to do a trade-in */
  IND_ECHANGE_POSSIBLE?: Maybe<Scalars['String']['output']>;
  /** Indicates if business is a franchise */
  IND_FRANCHISE?: Maybe<Scalars['String']['output']>;
  /** Indicates if listing can be found on the Internet */
  IND_INTERNET?: Maybe<Scalars['String']['output']>;
  /** Indicates if building dimensions are irregular If property type is commercial or condominium and condominium type is divided, then it represents the private portion or share area */
  IND_IRREGULIER_BATIMENT?: Maybe<Scalars['String']['output']>;
  /** Indicates if lot area dimensions are irregular */
  IND_IRREGULIER_TERRAIN?: Maybe<Scalars['String']['output']>;
  /** Indicates (O) if the rental has an option to buy */
  IND_OPTION_ACHAT?: Maybe<Scalars['String']['output']>;
  /** Indicates if lease can be renewed */
  IND_OPT_RENOUV_BAIL?: Maybe<Scalars['String']['output']>;
  /** Indicates if property is part of a foreclosure */
  IND_REPRISE_FINANCE?: Maybe<Scalars['String']['output']>;
  /** Indicates if the price is a price + taxes */
  IND_TAXES_PRIX_DEMANDE?: Maybe<Scalars['String']['output']>;
  /** Indicates if the price is a price + taxes */
  IND_TAXES_PRIX_LOCATION_DEMANDE?: Maybe<Scalars['String']['output']>;
  /** Indicates whether it is a sale without legal warranty. See the table "VALEURS_FIXES" for the possible values */
  IND_VENTE_SANS_GARANTIE_LEGALE?: Maybe<Scalars['String']['output']>;
  /** Private interactive visits offered */
  IND_VISITES_INTERACTIVE?: Maybe<Scalars['String']['output']>;
  /** Latitude of the listing */
  LATITUDE?: Maybe<Scalars['String']['output']>;
  /** Longitude of the listing */
  LONGITUDE?: Maybe<Scalars['String']['output']>;
  /** Municipality code where property is located */
  MUN_CODE?: Maybe<Scalars['String']['output']>;
  /** Total number of rooms */
  NB_CHAMBRES?: Maybe<Scalars['String']['output']>;
  /** Number of rooms on first floor and other floors */
  NB_CHAMBRES_HORS_SOL?: Maybe<Scalars['String']['output']>;
  /** Number of rooms in the basement */
  NB_CHAMBRES_SOUS_SOL?: Maybe<Scalars['String']['output']>;
  /** Number of water heater(s) rented by owner */
  NB_CHAUFFE_EAU_LOUE?: Maybe<Scalars['String']['output']>;
  /** Total floor number of building */
  NB_ETAGES?: Maybe<Scalars['String']['output']>;
  /** Number of rooms of single-family homes */
  NB_PIECES?: Maybe<Scalars['String']['output']>;
  /** Number of bathrooms for single-family homes and for main units of plexes (2 to 5 units) */
  NB_SALLES_BAINS?: Maybe<Scalars['String']['output']>;
  /** Number of powder rooms for single--family homes and number of powder rooms for main units of plexes (2 to 5 units) */
  NB_SALLES_EAU?: Maybe<Scalars['String']['output']>;
  /** Total number of units */
  NB_UNITES_TOTAL?: Maybe<Scalars['String']['output']>;
  /** Indicates on what floor the condo or apartment is located */
  NIVEAU?: Maybe<Scalars['String']['output']>;
  /** Usually indicates industrial park name or type of park */
  NOM_DU_PARC?: Maybe<Scalars['String']['output']>;
  /** Name of water body with direct or indirect access from property */
  NOM_PLAN_EAU?: Maybe<Scalars['String']['output']>;
  /** Street name in following format: "boul. de la Montagne ouest" */
  NOM_RUE_COMPLET?: Maybe<Scalars['String']['output']>;
  /** Start civic number */
  NO_CIVIQUE_DEBUT?: Maybe<Scalars['String']['output']>;
  /** End civic number */
  NO_CIVIQUE_FIN?: Maybe<Scalars['String']['output']>;
  /** Listing no */
  NO_INSCRIPTION?: Maybe<Scalars['String']['output']>;
  /** Construction distinctive feature (Being converted, century, historic or new) */
  PARTICULARITE_CONSTRUCTION?: Maybe<Scalars['String']['output']>;
  /** Indicates quota percentage. 99,9999 */
  POURC_QUOTE_PART?: Maybe<Scalars['String']['output']>;
  /** French description of what is located near the property */
  PRES_DE?: Maybe<Scalars['String']['output']>;
  /** Last requested selling price */
  PRIX_DEMANDE?: Maybe<Scalars['String']['output']>;
  /** Total asking price including QST/GST and refunds if applicable */
  PRIX_DEMANDE_TAXE_INCL?: Maybe<Scalars['String']['output']>;
  /** Latest requested price for rental */
  PRIX_LOCATION_DEMANDE?: Maybe<Scalars['String']['output']>;
  /** Dimensions of building depth.  If property type is commercial or condominium and condominium type is divided, then it represents the private portion or share area */
  PROFONDEUR_BATIMENT?: Maybe<Scalars['String']['output']>;
  /** Dimensions of lot area depth */
  PROFONDEUR_TERRAIN?: Maybe<Scalars['String']['output']>;
  /** Area where property is located */
  QUARTR_CODE?: Maybe<Scalars['String']['output']>;
  /** Indicates business corporate name */
  RAISON_SOCIALE?: Maybe<Scalars['String']['output']>;
  /** The potential gross revenue refers to the maximum other annual revenue that the property can generate if it is 100% occupied */
  REV_POT_BRUT_AU?: Maybe<Scalars['String']['output']>;
  /** The potential gross revenue refers to the maximum commercial annual revenue that the property can generate if it is 100% occupied */
  REV_POT_BRUT_COMM?: Maybe<Scalars['String']['output']>;
  /** The potential gross revenue refers to the maximum residential annual revenue that the property can generate if it is 100% occupied */
  REV_POT_BRUT_RES?: Maybe<Scalars['String']['output']>;
  /** The potential gross revenue refers to the maximum parking annual revenue that the property can generate if it is 100% occupied */
  REV_POT_BRUT_STAT?: Maybe<Scalars['String']['output']>;
  SSMA_TimeStamp?: Maybe<Scalars['String']['output']>;
  /** Indicates building surface area */
  SUPERFICIE_BATIMENT?: Maybe<Scalars['String']['output']>;
  /** Living area of private portion or share area */
  SUPERFICIE_HABITABLE?: Maybe<Scalars['String']['output']>;
  /** Lot surface area indicated with unit of measurement used by broker during data entry */
  SUPERFICIE_TERRAIN?: Maybe<Scalars['String']['output']>;
  /** ex. detached */
  TYPE_BATIMENT?: Maybe<Scalars['String']['output']>;
  /** Indicates if condominium is divided or undivided */
  TYPE_COPROPRIETE?: Maybe<Scalars['String']['output']>;
  /** Gross or per cadastral plan */
  TYPE_SUPERFICIE_HABITABLE?: Maybe<Scalars['String']['output']>;
  /** Unit of measurement of building dimensions. */
  UM_DIMENSION_BATIMENT?: Maybe<Scalars['String']['output']>;
  /** Unit of measurement for dimensions of lot area */
  UM_DIMENSION_TERRAIN?: Maybe<Scalars['String']['output']>;
  /** Unit of measurement of requested selling price */
  UM_PRIX_DEMANDE?: Maybe<Scalars['String']['output']>;
  /** Unit of measurement of requested price for rental */
  UM_PRIX_LOCATION_DEMANDE?: Maybe<Scalars['String']['output']>;
  /** Unit of measurement of building surface area */
  UM_SUPERFICIE_BATIMENT?: Maybe<Scalars['String']['output']>;
  /** Unit of measurement of living area of private portion or share area */
  UM_SUPERFICIE_HABITABLE?: Maybe<Scalars['String']['output']>;
  /** Unit of measurement for surface area */
  UM_SUPERFICIE_TERRAIN?: Maybe<Scalars['String']['output']>;
  /** Indicates URL link for a detailed description of the property.  IMPORTANT concatenate &Lang=F or &Lang=A to call the appropriate language */
  URL_DESC_DETAILLEE?: Maybe<Scalars['String']['output']>;
  /** Indicates URL link for a virtual visit of the property in English (250 car.) his field will be obsolete shortly.  See LIENS_ADDITIONNELS table */
  URL_VISITE_VIRTUELLE_ANGLAIS?: Maybe<Scalars['String']['output']>;
  /** Indicates URL link for a virtual visit of the property in French (250 car.) This field will be obsolete shortly.  See LIENS_ADDITIONNELS table */
  URL_VISITE_VIRTUELLE_FRANCAIS?: Maybe<Scalars['String']['output']>;
  /** This field is to indicate the property use for commercial listings */
  UTILISATION_COMMERCIALE?: Maybe<Scalars['String']['output']>;
};

export type CtrLiensAdditionnels = {
  __typename?: 'CtrLiensAdditionnels';
  /** English URL (250 car.) */
  LIEN_ANGLAIS?: Maybe<Scalars['String']['output']>;
  /** French URL (250 car.) */
  LIEN_FRANCAIS?: Maybe<Scalars['String']['output']>;
  /** Listing number */
  NO_INSCRIPTION?: Maybe<Scalars['String']['output']>;
  /** Display sequence */
  SEQ?: Maybe<Scalars['String']['output']>;
  /** Link type.  See table VALEURS_FIXES for description */
  TYPE_LIEN?: Maybe<Scalars['String']['output']>;
};

export type CtrMembres = {
  __typename?: 'CtrMembres';
  /** Board office code */
  BUR_CODE?: Maybe<Scalars['String']['output']>;
  /** Previously SEXE */
  CHAMP_INUTILISE_1?: Maybe<Scalars['String']['output']>;
  /** Previously NOM_FICHIER_PHOTO */
  CHAMP_INUTILISE_2?: Maybe<Scalars['String']['output']>;
  /** Board member code */
  CODE?: Maybe<Scalars['String']['output']>;
  /** Indicates the member's language code */
  CODE_LANGUE?: Maybe<Scalars['String']['output']>;
  /** Email address */
  COURRIEL?: Maybe<Scalars['String']['output']>;
  /** Modification date of broker */
  DATE_MODIFICATION?: Maybe<Scalars['String']['output']>;
  /** English broker introduction video link (250) car. */
  LIEN_VIDEO_A?: Maybe<Scalars['String']['output']>;
  /** French broker introduction video link (250) car. */
  LIEN_VIDEO_F?: Maybe<Scalars['String']['output']>;
  /** Individual last name */
  NOM?: Maybe<Scalars['String']['output']>;
  /** Name of the corporation */
  NOM_SOCIETE?: Maybe<Scalars['String']['output']>;
  /** Licence number allocated to real estate broker by OACIQ */
  NO_CERTIFICAT?: Maybe<Scalars['String']['output']>;
  /** Url for broker's photo */
  PHOTO_URL?: Maybe<Scalars['String']['output']>;
  /** Individual first name */
  PRENOM?: Maybe<Scalars['String']['output']>;
  /** English broker introduction text (500 car. + carriage returns) in HTML format */
  PRESENTATION_A?: Maybe<Scalars['String']['output']>;
  /** French broker introduction text (500 car. + carriage returns) in HTML format */
  PRESENTATION_F?: Maybe<Scalars['String']['output']>;
  /** Internet address of broker's Web page */
  SITE_WEB?: Maybe<Scalars['String']['output']>;
  SSMA_TimeStamp?: Maybe<Scalars['String']['output']>;
  /** Main telephone number */
  TELEPHONE_1?: Maybe<Scalars['String']['output']>;
  /** Secondary telephone number */
  TELEPHONE_2?: Maybe<Scalars['String']['output']>;
  /** Fax number */
  TELEPHONE_FAX?: Maybe<Scalars['String']['output']>;
  /** Professionnal title (abreviation) */
  TITRE_PROFESSIONNEL?: Maybe<Scalars['String']['output']>;
  /** Licence type allocated to broker by OACIQ */
  TYPE_CERTIFICAT?: Maybe<Scalars['String']['output']>;
  /** English description of corporation type */
  TYPE_SOCIETE_DESC_A?: Maybe<Scalars['String']['output']>;
  /** French description of corporation type */
  TYPE_SOCIETE_DESC_F?: Maybe<Scalars['String']['output']>;
};

export type CtrMembresMediasSociaux = {
  __typename?: 'CtrMembresMediasSociaux';
  /** Social media link (250 car.) */
  LIEN_MEDIA_SOCIAL?: Maybe<Scalars['String']['output']>;
  /** Member code */
  MEMBRE_CODE?: Maybe<Scalars['String']['output']>;
  /** Social media type.  See table VALEURS_FIXES for descriptions */
  TYPE_MEDIA_SOCIAL?: Maybe<Scalars['String']['output']>;
};

/** taken from information_schema.columns (mssql) */
export type CtrMetaField = {
  __typename?: 'CtrMetaField';
  /** mssql: column_default */
  default?: Maybe<Scalars['String']['output']>;
  /** internal description translated to FR from official Centris extended properties -- done by Ildar */
  description_custom?: Maybe<Scalars['String']['output']>;
  /** official english description provided by Centris in AccessDB files -- extended_properties in MSSQL */
  description_official?: Maybe<Scalars['String']['output']>;
  /** mssql: is_nullable */
  is_nullable?: Maybe<Scalars['Boolean']['output']>;
  /** EN label for public display */
  label_en?: Maybe<Scalars['String']['output']>;
  /** FR label for public display */
  label_fr?: Maybe<Scalars['String']['output']>;
  /** mssql: column_name */
  name: Scalars['String']['output'];
  /** mssql: ordinal_position */
  position: Scalars['Int']['output'];
  /** mssql: table_name */
  table: Scalars['String']['output'];
  /** mssql: data_type */
  type?: Maybe<Scalars['String']['output']>;
};

export type CtrMetaFieldInput = {
  label_en?: InputMaybe<Scalars['String']['input']>;
  label_fr?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  table: Scalars['String']['input'];
};

/** taken from information_schema.tables (mssql) */
export type CtrMetaTable = {
  __typename?: 'CtrMetaTable';
  label?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** static tables are not updated frequently (~ once a year maybe) */
  static: Scalars['Boolean']['output'];
};

export type CtrMunicipalites = {
  __typename?: 'CtrMunicipalites';
  CODE?: Maybe<Scalars['String']['output']>;
  CUSTOM_EN?: Maybe<Scalars['String']['output']>;
  CUSTOM_FR?: Maybe<Scalars['String']['output']>;
  DESCRIPTION?: Maybe<Scalars['String']['output']>;
  REGION_CODE?: Maybe<Scalars['String']['output']>;
};

export type CtrPhotos = {
  __typename?: 'CtrPhotos';
  /** Please refer to VALEURS_FIXES table for available values, it indicates the picture object */
  CODE_DESCRIPTION_PHOTO?: Maybe<Scalars['String']['output']>;
  DATE_MODIFICATION?: Maybe<Scalars['String']['output']>;
  /** English description of picture */
  DESCRIPTION_ANGLAISE?: Maybe<Scalars['String']['output']>;
  /** French description of picture */
  DESCRIPTION_FRANCAISE?: Maybe<Scalars['String']['output']>;
  /** Picture file name; board code + mls number + - + seq + .jpg */
  NOM_FICHIER_PHOTO?: Maybe<Scalars['String']['output']>;
  /** Board code listing number + mls_number */
  NO_INSCRIPTION?: Maybe<Scalars['String']['output']>;
  /** # Version of picture */
  NO_VERSION?: Maybe<Scalars['String']['output']>;
  /** Picture URL */
  PhotoURL?: Maybe<Scalars['String']['output']>;
  /** Picture sequence */
  SEQ?: Maybe<Scalars['String']['output']>;
};

export type CtrPiecesUnites = {
  __typename?: 'CtrPiecesUnites';
  /** English description for other flooring */
  AU_COUVRE_PLANCHER_A?: Maybe<Scalars['String']['output']>;
  /** French description for other flooring */
  AU_COUVRE_PLANCHER_F?: Maybe<Scalars['String']['output']>;
  /** English description for other floor */
  AU_NIVEAU_INFO_A?: Maybe<Scalars['String']['output']>;
  /** French description for other floor */
  AU_NIVEAU_INFO_F?: Maybe<Scalars['String']['output']>;
  /** English description for other room */
  AU_PIECE_INFO_A?: Maybe<Scalars['String']['output']>;
  /** French description for other room */
  AU_PIECE_INFO_F?: Maybe<Scalars['String']['output']>;
  /** Flooring code */
  COUVRE_PLANCHER_CODE?: Maybe<Scalars['String']['output']>;
  /** Room dimensions. */
  DIMENSIONS?: Maybe<Scalars['String']['output']>;
  /** Indicates if the room has a fireplace/stove */
  IND_FOYER_POELE?: Maybe<Scalars['String']['output']>;
  /** Indicates if room dimensions are irregular */
  IND_IRREGULIER?: Maybe<Scalars['String']['output']>;
  /** English description for additionnal information */
  INFO_SUPP_A?: Maybe<Scalars['String']['output']>;
  /** French description for additionnal information */
  INFO_SUPP_F?: Maybe<Scalars['String']['output']>;
  /** Floor where room is located */
  NIVEAU?: Maybe<Scalars['String']['output']>;
  /** Listing number */
  NO_INSCRIPTION?: Maybe<Scalars['String']['output']>;
  /** Type of room code */
  PIECE_CODE?: Maybe<Scalars['String']['output']>;
  /** Order in which the rooms were originally entered */
  SEQ?: Maybe<Scalars['String']['output']>;
  /** Unit identifier (sequence) */
  SEQ_UNITE_DET?: Maybe<Scalars['String']['output']>;
};

export type CtrQuartiers = {
  __typename?: 'CtrQuartiers';
  /** Code */
  CODE?: Maybe<Scalars['String']['output']>;
  CUSTOM_EN?: Maybe<Scalars['String']['output']>;
  CUSTOM_FR?: Maybe<Scalars['String']['output']>;
  /** English description */
  DESCRIPTION_ANGLAISE?: Maybe<Scalars['String']['output']>;
  /** French description */
  DESCRIPTION_FRANCAISE?: Maybe<Scalars['String']['output']>;
  /** Municipality code */
  MUN_CODE?: Maybe<Scalars['String']['output']>;
};

export type CtrRegions = {
  __typename?: 'CtrRegions';
  CODE?: Maybe<Scalars['String']['output']>;
  CUSTOM_EN?: Maybe<Scalars['String']['output']>;
  CUSTOM_FR?: Maybe<Scalars['String']['output']>;
  /** English description */
  DESCRIPTION_ANGLAISE?: Maybe<Scalars['String']['output']>;
  /** French description */
  DESCRIPTION_FRANCAISE?: Maybe<Scalars['String']['output']>;
};

export type CtrRemarques = {
  __typename?: 'CtrRemarques';
  /** Previously IND_INTERNET */
  CHAMP_INUTILISE_1?: Maybe<Scalars['String']['output']>;
  /** Previously IND_SIA */
  CHAMP_INUTILISE_2?: Maybe<Scalars['String']['output']>;
  /** Language code */
  CODE_LANGUE?: Maybe<Scalars['String']['output']>;
  /** Listing no */
  NO_INSCRIPTION?: Maybe<Scalars['String']['output']>;
  /** Remark number */
  NO_REMARQUE?: Maybe<Scalars['String']['output']>;
  /** Line number */
  ORDRE_AFFICHAGE?: Maybe<Scalars['String']['output']>;
  SSMA_TimeStamp?: Maybe<Scalars['String']['output']>;
  /** Remark text (650 characters) */
  TEXTE?: Maybe<Scalars['String']['output']>;
};

export type CtrRenovations = {
  __typename?: 'CtrRenovations';
  /** Indicates year of renovation */
  ANNEE?: Maybe<Scalars['String']['output']>;
  /** Previously POURC */
  CHAMP_INUTILISE_1?: Maybe<Scalars['String']['output']>;
  /** English explanations about nature of renovation */
  INFORMATIONS_ANGLAISES?: Maybe<Scalars['String']['output']>;
  /** French explanations about nature of renovation */
  INFORMATIONS_FRANCAISES?: Maybe<Scalars['String']['output']>;
  /** Amount ($) related to the renovation */
  MONTANT?: Maybe<Scalars['String']['output']>;
  /** Listing no */
  NO_INSCRIPTION?: Maybe<Scalars['String']['output']>;
  /** Item that was renovated */
  RENOVATION_TYPE?: Maybe<Scalars['String']['output']>;
  /** Sequence allowing to single out each renovation */
  SEQ?: Maybe<Scalars['String']['output']>;
};

export type CtrSousTypeCaracteristiques = {
  __typename?: 'CtrSousTypeCaracteristiques';
  /** Code */
  CODE?: Maybe<Scalars['String']['output']>;
  CUSTOM_EN?: Maybe<Scalars['String']['output']>;
  CUSTOM_FR?: Maybe<Scalars['String']['output']>;
  /** Summarized English description */
  DESCRIPTION_ABREGEE_ANGLAISE?: Maybe<Scalars['String']['output']>;
  /** Summarized French description */
  DESCRIPTION_ABREGEE_FRANCAISE?: Maybe<Scalars['String']['output']>;
  /** English description */
  DESCRIPTION_ANGLAISE?: Maybe<Scalars['String']['output']>;
  /** French description */
  DESCRIPTION_FRANCAISE?: Maybe<Scalars['String']['output']>;
  /** Caracteristic code */
  TCAR_CODE?: Maybe<Scalars['String']['output']>;
};

/** input vars to pass when setting custom label for any single entry in any of the static tables */
export type CtrStaticCustomInput = {
  /** custom english label to override default Centris value */
  custom_en?: InputMaybe<Scalars['String']['input']>;
  /** custom french label to override default Centris value */
  custom_fr?: InputMaybe<Scalars['String']['input']>;
  /** unique keys to use for finding proper key */
  keys: Array<InputMaybe<Scalars['String']['input']>>;
  /** which table to update */
  table: Scalars['String']['input'];
  /** values matching unique keys (same index position) to filter in mongo */
  vals: Array<InputMaybe<Scalars['String']['input']>>;
};

/** Static Centris MLS tables (from meta_tables) */
export enum CtrStaticTables {
  GenresProprietes = 'GENRES_PROPRIETES',
  Municipalites = 'MUNICIPALITES',
  Quartiers = 'QUARTIERS',
  Regions = 'REGIONS',
  SousTypeCaracteristiques = 'SOUS_TYPE_CARACTERISTIQUES',
  TypesBannieres = 'TYPES_BANNIERES',
  TypeCaracteristiques = 'TYPE_CARACTERISTIQUES',
  ValeursFixes = 'VALEURS_FIXES'
}

export type CtrStaticUniqueKeys = {
  __typename?: 'CtrStaticUniqueKeys';
  GENRES_PROPRIETES?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  MUNICIPALITES?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  QUARTIERS?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  REGIONS?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SOUS_TYPE_CARACTERISTIQUES?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  TYPES_BANNIERES?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  TYPE_CARACTERISTIQUES?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  VALEURS_FIXES?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CtrTypeCaracteristiques = {
  __typename?: 'CtrTypeCaracteristiques';
  /** Possible feature type code */
  CODE?: Maybe<Scalars['String']['output']>;
  CUSTOM_EN?: Maybe<Scalars['String']['output']>;
  CUSTOM_FR?: Maybe<Scalars['String']['output']>;
  /** Summarized English description of feature type */
  DESCRIPTION_ABREGEE_ANGLAISE?: Maybe<Scalars['String']['output']>;
  /** Summarized French feature description */
  DESCRIPTION_ABREGEE_FRANCAISE?: Maybe<Scalars['String']['output']>;
  /** English description of feature type */
  DESCRIPTION_ANGLAISE?: Maybe<Scalars['String']['output']>;
  /** French description of feature */
  DESCRIPTION_FRANCAISE?: Maybe<Scalars['String']['output']>;
  /** Indicates if it is possible to choose more than one value for feature type */
  IND_PLUSIEURS_CRITERES?: Maybe<Scalars['String']['output']>;
};

export enum CtrType_Abri {
  Atta = 'ATTA',
  Au = 'AU',
  Det = 'DET',
  Doub = 'DOUB'
}

export enum CtrType_Adap {
  Cuia = 'CUIA',
  Douc = 'DOUC',
  Enta = 'ENTA',
  Levp = 'LEVP',
  Mont = 'MONT',
  Pfor = 'PFOR',
  Ramp = 'RAMP',
  Sdba = 'SDBA'
}

export enum CtrType_Alle {
  Asph = 'ASPH',
  Au = 'AU',
  Beto = 'BETO',
  Doub = 'DOUB',
  Nil = 'NIL',
  Npav = 'NPAV',
  Uni = 'UNI'
}

export enum CtrType_Amen {
  Clot = 'CLOT',
  Haie = 'HAIE',
  Pati = 'PATI',
  Pay = 'PAY'
}

export enum CtrType_Anim {
  Agne = 'AGNE',
  Au = 'AU',
  Autr = 'AUTR',
  Biso = 'BISO',
  Boeu = 'BOEU',
  Cail = 'CAIL',
  Chev = 'CHEV',
  Fais = 'FAIS',
  Mout = 'MOUT',
  Porc = 'PORC',
  Poul = 'POUL',
  Vach = 'VACH',
  Veau = 'VEAU'
}

export enum CtrType_Armo {
  Au = 'AU',
  Bois = 'BOIS',
  Melm = 'MELM',
  Poly = 'POLY',
  Stra = 'STRA',
  Ther = 'THER'
}

export enum CtrType_Bass {
  Dall = 'DALL'
}

export enum CtrType_Bati {
  Au = 'AU',
  Ecur = 'ECUR',
  Etab = 'ETAB',
  Gara = 'GARA',
  Grng = 'GRNG',
  Hang = 'HANG',
  Lait = 'LAIT',
  Porc = 'PORC',
  Poul = 'POUL',
  Remi = 'REMI'
}

export enum CtrType_Chau {
  Airs = 'AIRS',
  Au = 'AU',
  Eauc = 'EAUC',
  Pcon = 'PCON',
  Pelc = 'PELC',
  Radi = 'RADI',
  Ther = 'THER'
}

export enum CtrType_Eau {
  Amu = 'AMU',
  Au = 'AU',
  Aucn = 'AUCN',
  Capt = 'CAPT',
  Cit = 'CIT',
  Comp = 'COMP',
  Coop = 'COOP',
  Elac = 'ELAC',
  Inco = 'INCO',
  Pa = 'PA',
  Pf = 'PF',
  Priv = 'PRIV',
  Ps = 'PS',
  Pt = 'PT'
}

export enum CtrType_Effn {
  Cen2 = 'CEN2',
  Cenr = 'CENR',
  Eoli = 'EOLI',
  Leed = 'LEED',
  Netz = 'NETZ',
  Novo = 'NOVO',
  Pntz = 'PNTZ',
  Sola = 'SOLA',
  Vert = 'VERT'
}

export enum CtrType_Ener {
  Au = 'AU',
  Bien = 'BIEN',
  Bois = 'BOIS',
  Elec = 'ELEC',
  Gazn = 'GAZN',
  Geot = 'GEOT',
  Humz = 'HUMZ',
  Prop = 'PROP',
  Sola = 'SOLA'
}

export enum CtrType_Equi {
  Aeau = 'AEAU',
  Asp = 'ASP',
  Au = 'AU',
  Balc = 'BALC',
  Born = 'BORN',
  Clmc = 'CLMC',
  Clmm = 'CLMM',
  Cour = 'COUR',
  Deau = 'DEAU',
  Eair = 'EAIR',
  Ens = 'ENS',
  Intp = 'INTP',
  Mchr = 'MCHR',
  Meub = 'MEUB',
  Pele = 'PELE',
  Pntr = 'PNTR',
  Rems = 'REMS',
  Saun = 'SAUN',
  Semi = 'SEMI',
  Syal = 'SYAL',
  Thec = 'THEC',
  Them = 'THEM'
}

export enum CtrType_Expl {
  Au = 'AU',
  Erab = 'ERAB',
  Gen = 'GEN',
  Hort = 'HORT',
  Lait = 'LAIT',
  Mara = 'MARA',
  Pepi = 'PEPI',
  Verg = 'VERG',
  Vign = 'VIGN'
}

export enum CtrType_Facc {
  Asce = 'ASCE',
  Exca = 'EXCA',
  Hand = 'HAND'
}

export enum CtrType_Fene {
  Alum = 'ALUM',
  Au = 'AU',
  Bois = 'BOIS',
  Pvc = 'PVC'
}

export enum CtrType_Fond {
  Au = 'AU',
  Beto = 'BETO',
  Blbe = 'BLBE',
  Bois = 'BOIS',
  Pier = 'PIER',
  Pilo = 'PILO'
}

export enum CtrType_Fopo {
  Annx = 'ANNX',
  Au = 'AU',
  Bois = 'BOIS',
  Fgra = 'FGRA',
  Gaz = 'GAZ',
  Gran = 'GRAN',
  Mazo = 'MAZO',
  Pab = 'PAB',
  Pgaz = 'PGAZ',
  Pmaz = 'PMAZ'
}

export enum CtrType_Gara {
  Att = 'ATT',
  Au = 'AU',
  Chau = 'CHAU',
  Det = 'DET',
  Doub = 'DOUB',
  Intg = 'INTG',
  Simp = 'SIMP',
  Tand = 'TAND'
}

export enum CtrType_Gcom {
  Agri = 'AGRI',
  Aimm = 'AIMM',
  Ameu = 'AMEU',
  Anim = 'ANIM',
  Anti = 'ANTI',
  Apic = 'APIC',
  Appm = 'APPM',
  Aren = 'AREN',
  Arti = 'ARTI',
  Aspo = 'ASPO',
  Atel = 'ATEL',
  Au = 'AU',
  Aube = 'AUBE',
  Auto = 'AUTO',
  Avoy = 'AVOY',
  Bar = 'BAR',
  Bijo = 'BIJO',
  Bill = 'BILL',
  Bouc = 'BOUC',
  Boul = 'BOUL',
  Bout = 'BOUT',
  Bras = 'BRAS',
  Bron = 'BRON',
  Buan = 'BUAN',
  Bure = 'BURE',
  Cabe = 'CABE',
  Cade = 'CADE',
  Camp = 'CAMP',
  Carr = 'CARR',
  Cass = 'CASS',
  Ccom = 'CCOM',
  Char = 'CHAR',
  Cine = 'CINE',
  Clin = 'CLIN',
  Coif = 'COIF',
  Coih = 'COIH',
  Comp = 'COMP',
  Conf = 'CONF',
  Cord = 'CORD',
  Cphy = 'CPHY',
  Crem = 'CREM',
  Csan = 'CSAN',
  Cult = 'CULT',
  Cvid = 'CVID',
  Deco = 'DECO',
  Deme = 'DEME',
  Depa = 'DEPA',
  Dist = 'DIST',
  Eben = 'EBEN',
  Ecol = 'ECOL',
  Econ = 'ECON',
  Egli = 'EGLI',
  Elec = 'ELEC',
  Eleo = 'ELEO',
  Emba = 'EMBA',
  Epic = 'EPIC',
  Eque = 'EQUE',
  Erab = 'ERAB',
  Fabr = 'FABR',
  Fart = 'FART',
  Fleu = 'FLEU',
  Frui = 'FRUI',
  Gara = 'GARA',
  Gard = 'GARD',
  Gite = 'GITE',
  Golf = 'GOLF',
  Homo = 'HOMO',
  Impr = 'IMPR',
  Info = 'INFO',
  Jour = 'JOUR',
  Laut = 'LAUT',
  Libr = 'LIBR',
  Ling = 'LING',
  Maga = 'MAGA',
  Mali = 'MALI',
  Mari = 'MARI',
  Mass = 'MASS',
  Mcon = 'MCON',
  Merc = 'MERC',
  Mote = 'MOTE',
  Mret = 'MRET',
  Nett = 'NETT',
  Pape = 'PAPE',
  Pati = 'PATI',
  Paut = 'PAUT',
  Pein = 'PEIN',
  Pepi = 'PEPI',
  Phar = 'PHAR',
  Plom = 'PLOM',
  Pour = 'POUR',
  Quil = 'QUIL',
  Quin = 'QUIN',
  Rdis = 'RDIS',
  Rest = 'REST',
  Rmeu = 'RMEU',
  Rrap = 'RRAP',
  Sbea = 'SBEA',
  Sdom = 'SDOM',
  Senc = 'SENC',
  Serr = 'SERR',
  Seru = 'SERU',
  Spho = 'SPHO',
  Srec = 'SREC',
  Sser = 'SSER',
  Stat = 'STAT',
  Taba = 'TABA',
  Tave = 'TAVE',
  Trai = 'TRAI',
  Tran = 'TRAN',
  Usin = 'USIN',
  Vari = 'VARI',
  Verg = 'VERG',
  Vign = 'VIGN'
}

export enum CtrType_Loc {
  Aeau = 'AEAU',
  Apch = 'APCH',
  Au = 'AU',
  Ceau = 'CEAU',
  Syal = 'SYAL',
  Ther = 'THER'
}

export enum CtrType_Mach {
  Abrv = 'ABRV',
  Au = 'AU',
  Char = 'CHAR',
  Conv = 'CONV',
  Ecur = 'ECUR',
  Epnf = 'EPNF',
  Fan = 'FAN',
  Fauc = 'FAUC',
  Fend = 'FEND',
  Foss = 'FOSS',
  Gen = 'GEN',
  Hers = 'HERS',
  Meln = 'MELN',
  Mntb = 'MNTB',
  Rato = 'RATO',
  Resl = 'RESL',
  Roul = 'ROUL',
  Sech = 'SECH',
  Semo = 'SEMO',
  Silo = 'SILO',
  Strt = 'STRT',
  Trac = 'TRAC',
  Tray = 'TRAY',
  Visg = 'VISG'
}

export enum CtrType_Pare {
  Acie = 'ACIE',
  Agre = 'AGRE',
  Alum = 'ALUM',
  Amia = 'AMIA',
  Asph = 'ASPH',
  Au = 'AU',
  Bced = 'BCED',
  Beto = 'BETO',
  Bois = 'BOIS',
  Briq = 'BRIQ',
  Cced = 'CCED',
  Fibp = 'FIBP',
  Pbet = 'PBET',
  Pbri = 'PBRI',
  Pier = 'PIER',
  Sbrq = 'SBRQ',
  Spie = 'SPIE',
  Stuc = 'STUC',
  Viny = 'VINY'
}

export enum CtrType_Part {
  Aeau = 'AEAU',
  Au = 'AU',
  Avoi = 'AVOI',
  Boid = 'BOID',
  Boim = 'BOIM',
  Bois = 'BOIS',
  Cbio = 'CBIO',
  Coin = 'COIN',
  Culs = 'CULS',
  Eau = 'EAU',
  Encl = 'ENCL',
  Ev1 = 'EV1',
  Ev2 = 'EV2',
  Intg = 'INTG',
  Loue = 'LOUE',
  Mixt = 'MIXT',
  Motn = 'MOTN',
  Motp = 'MOTP',
  Priv = 'PRIV',
  Sais = 'SAIS',
  Ski = 'SKI',
  Ucoi = 'UCOI',
  Vilg = 'VILG'
}

export enum CtrType_Pisc {
  Au = 'AU',
  Chau = 'CHAU',
  Creu = 'CREU',
  Ht = 'HT',
  Int = 'INT'
}

export enum CtrType_Prox {
  Au = 'AU',
  Auto = 'AUTO',
  Cegp = 'CEGP',
  Gcpe = 'GCPE',
  Golf = 'GOLF',
  Hop = 'HOP',
  Parc = 'PARC',
  Pcyc = 'PCYC',
  Prim = 'PRIM',
  Rem = 'REM',
  Salp = 'SALP',
  Sec = 'SEC',
  Sfon = 'SFON',
  Smot = 'SMOT',
  Svtt = 'SVTT',
  Trsp = 'TRSP',
  Univ = 'UNIV'
}

export enum CtrType_Repe {
  Age = 'AGE',
  Anim = 'ANIM',
  Autn = 'AUTN',
  Auto = 'AUTO',
  Auts = 'AUTS',
  Chat = 'CHAT',
  Chie = 'CHIE',
  Cond = 'COND',
  Fume = 'FUME',
  Locc = 'LOCC',
  Locn = 'LOCN',
  Nani = 'NANI',
  Nfum = 'NFUM'
}

export enum CtrType_Sdb {
  Attn = 'ATTN',
  Au = 'AU',
  Brem = 'BREM',
  Dind = 'DIND',
  Tmas = 'TMAS'
}

export enum CtrType_Sdis {
  Airc = 'AIRC',
  Bate = 'BATE',
  Bicy = 'BICY',
  Born = 'BORN',
  Bric = 'BRIC',
  Buan = 'BUAN',
  Chud = 'CHUD',
  Conc = 'CONC',
  Conf = 'CONF',
  Cour = 'COUR',
  Deau = 'DEAU',
  Dein = 'DEIN',
  Exer = 'EXER',
  Medi = 'MEDI',
  Pext = 'PEXT',
  Pint = 'PINT',
  Repa = 'REPA',
  Rext = 'REXT',
  Rint = 'RINT',
  Saun = 'SAUN',
  Scom = 'SCOM',
  Stav = 'STAV',
  Sygc = 'SYGC',
  Toit = 'TOIT'
}

export enum CtrType_Ss {
  Amnn = 'AMNN',
  Amnp = 'AMNP',
  Amnt = 'AMNT',
  Au = 'AU',
  Aucn = 'AUCN',
  Bas = 'BAS',
  Entr = 'ENTR',
  Vsan = 'VSAN'
}

export enum CtrType_Stac {
  Abri = 'ABRI',
  Alle = 'ALLE',
  Gara = 'GARA'
}

export enum CtrType_Stao {
  Abri = 'ABRI',
  Alle = 'ALLE',
  Gara = 'GARA'
}

export enum CtrType_Stat {
  Abri = 'ABRI',
  Ext = 'EXT',
  Gara = 'GARA',
  Vign = 'VIGN'
}

export enum CtrType_Stax {
  Abri = 'ABRI',
  Alle = 'ALLE',
  Gara = 'GARA'
}

export enum CtrType_Syeg {
  Au = 'AU',
  Aucn = 'AUCN',
  Biof = 'BIOF',
  Bion = 'BION',
  Cham = 'CHAM',
  Egmu = 'EGMU',
  Fse = 'FSE',
  Fses = 'FSES',
  Inco = 'INCO',
  Priv = 'PRIV',
  Pusp = 'PUSP'
}

export enum CtrType_Tcom {
  Deta = 'DETA',
  Entr = 'ENTR',
  Fabr = 'FABR',
  Gros = 'GROS',
  Serv = 'SERV'
}

export enum CtrType_Tfen {
  Au = 'AU',
  Coul = 'COUL',
  Guil = 'GUIL',
  Man = 'MAN',
  Osba = 'OSBA',
  Pfen = 'PFEN'
}

export enum CtrType_Toit {
  Au = 'AU',
  Baa = 'BAA',
  Bced = 'BCED',
  Bigr = 'BIGR',
  Mbel = 'MBEL',
  Tol = 'TOL'
}

export enum CtrType_Topo {
  Acci = 'ACCI',
  Au = 'AU',
  Escr = 'ESCR',
  Pent = 'PENT',
  Plat = 'PLAT',
  Ravi = 'RAVI'
}

export enum CtrType_Vue {
  Au = 'AU',
  Eau = 'EAU',
  Mont = 'MONT',
  Pano = 'PANO',
  Vill = 'VILL'
}

export enum CtrType_Zong {
  Agr = 'AGR',
  Comm = 'COMM',
  Fore = 'FORE',
  Ind = 'IND',
  Mult = 'MULT',
  Recr = 'RECR',
  Res = 'RES',
  Vilg = 'VILG'
}

export type CtrTypesBannieres = {
  __typename?: 'CtrTypesBannieres';
  CODE?: Maybe<Scalars['String']['output']>;
  CUSTOM_EN?: Maybe<Scalars['String']['output']>;
  CUSTOM_FR?: Maybe<Scalars['String']['output']>;
  NOM_ABREGE_ANGLAIS?: Maybe<Scalars['String']['output']>;
  NOM_ABREGE_FRANCAIS?: Maybe<Scalars['String']['output']>;
  NOM_ANGLAIS?: Maybe<Scalars['String']['output']>;
  NOM_FRANCAIS?: Maybe<Scalars['String']['output']>;
};

export type CtrUnitesDetaillees = {
  __typename?: 'CtrUnitesDetaillees';
  /** English description for other inclusions */
  AU_INCLUS_INFO_A?: Maybe<Scalars['String']['output']>;
  /** French description for other inclusions */
  AU_INCLUS_INFO_F?: Maybe<Scalars['String']['output']>;
  /** Indicates if cable/tv is included (can be NULL) */
  INCLUS_CABLETELE?: Maybe<Scalars['String']['output']>;
  /** Indicates if heating is included or not  (can be NULL) */
  INCLUS_CHAUFFAGE?: Maybe<Scalars['String']['output']>;
  /** Indicates if air conditioning  is included (can be NULL) */
  INCLUS_CLIMATISATION?: Maybe<Scalars['String']['output']>;
  /** Indicates if  snow removal is included or not  (can be NULL) */
  INCLUS_DENEIGEMENT?: Maybe<Scalars['String']['output']>;
  /** Indicates if hot water is included or not  (can be NULL) */
  INCLUS_EAU_CHAUDE?: Maybe<Scalars['String']['output']>;
  /** Indicates if electricity is included or not  (can be NULL) */
  INCLUS_ELECTRICITE?: Maybe<Scalars['String']['output']>;
  /** Indicates if internet is included (can be NULL) */
  INCLUS_INTERNET?: Maybe<Scalars['String']['output']>;
  /** Indicates if  the unit is furnished or not  (can be NULL) */
  INCLUS_MEUBLE?: Maybe<Scalars['String']['output']>;
  /** Indicates if  lawn care is included or not  (can be NULL) */
  INCLUS_PELOUSE?: Maybe<Scalars['String']['output']>;
  /** Indicates if  the unit is partially furnished or not  (can be NULL) */
  INCLUS_SEMI_MEUBLE?: Maybe<Scalars['String']['output']>;
  /** Indicates if  water taxes  are included or not  (can be NULL) */
  INCLUS_TAXE_EAU?: Maybe<Scalars['String']['output']>;
  /** Indicates if the unit is vacant */
  IND_VACANT?: Maybe<Scalars['String']['output']>;
  /** Number of bedrooms in the unit */
  NB_CHAMBRES?: Maybe<Scalars['String']['output']>;
  /** Number of rooms in the unit */
  NB_PIECES?: Maybe<Scalars['String']['output']>;
  /** Indicates the number of outdoor parking spaces included */
  NB_STAT_EXTERIEURS?: Maybe<Scalars['String']['output']>;
  /** Indicates the number of indoor parking spaces included */
  NB_STAT_INTERIEURS?: Maybe<Scalars['String']['output']>;
  /** Listing number */
  NO_INSCRIPTION?: Maybe<Scalars['String']['output']>;
  /** Unit sequence */
  SEQ?: Maybe<Scalars['String']['output']>;
  SSMA_TimeStamp?: Maybe<Scalars['String']['output']>;
  /** Living area of the unit */
  SUPERFICIE_TOTALE?: Maybe<Scalars['String']['output']>;
  /** Indicates detailed unit type. See table VALEURS_FIXES */
  TYPE_UNITE_DET?: Maybe<Scalars['String']['output']>;
  /** Living area unit of measurement of the unit */
  UM_SUPERFICIE_TOTALE?: Maybe<Scalars['String']['output']>;
};

export type CtrUnitesSommaires = {
  __typename?: 'CtrUnitesSommaires';
  /** English description for other revenue type */
  AU_UNITE_REVENU_INFO_A?: Maybe<Scalars['String']['output']>;
  /** French description for other revenue type */
  AU_UNITE_REVENU_INFO_F?: Maybe<Scalars['String']['output']>;
  /** Number of units */
  NB_TOTAL_UNITES?: Maybe<Scalars['String']['output']>;
  /** Number of vacant units */
  NB_UNITES_VACANTES?: Maybe<Scalars['String']['output']>;
  /** Listing number */
  NO_INSCRIPTION?: Maybe<Scalars['String']['output']>;
  /** Sequence */
  SEQ?: Maybe<Scalars['String']['output']>;
  /** See VALEURS_FIXES table for summary unit description */
  TYPE_UNITE_SOM?: Maybe<Scalars['String']['output']>;
};

export enum CtrVfCategoriePropriete {
  C = 'C',
  F = 'F',
  I = 'I',
  M = 'M',
  P = 'P',
  R = 'R',
  T = 'T'
}

export enum CtrVfCodeAnneeConstruction {
  Acons = 'ACONS',
  Cons = 'CONS',
  Hist = 'HIST',
  Inco = 'INCO'
}

export enum CtrVfCodeDeclarationVendeur {
  Ai = 'AI'
}

export enum CtrVfCodeDescriptionPhoto {
  Acon = 'ACON',
  Aerienne = 'AERIENNE',
  Apla = 'APLA',
  Ascn = 'ASCN',
  Ate = 'ATE',
  Au = 'AU',
  Balcon = 'BALCON',
  Bar = 'BAR',
  Beau = 'BEAU',
  Bib = 'BIB',
  Boise = 'BOISE',
  Bou = 'BOU',
  Bur = 'BUR',
  Cac = 'CAC',
  Cafeteria = 'CAFETERIA',
  Cav = 'CAV',
  Cavevin = 'CAVEVIN',
  Ccp = 'CCP',
  Cine = 'CINE',
  Comm = 'COMM',
  Corridor = 'CORRIDOR',
  Cour = 'COUR',
  Cr = 'CR',
  Cui = 'CUI',
  Cuisinette = 'CUISINETTE',
  Econ = 'ECON',
  Ecur = 'ECUR',
  Entree = 'ENTREE',
  Entrepot = 'ENTREPOT',
  Erabliere = 'ERABLIERE',
  Esca = 'ESCA',
  Expedition = 'EXPEDITION',
  Exte = 'EXTE',
  Faca = 'FACA',
  Facarr = 'FACARR',
  Gara = 'GARA',
  Garc = 'GARC',
  Gran = 'GRAN',
  Hal = 'HAL',
  Int = 'INT',
  Interg = 'INTERG',
  Jardin = 'JARDIN',
  Loft = 'LOFT',
  Logement = 'LOGEMENT',
  Mari = 'MARI',
  Mez = 'MEZ',
  Mmod = 'MMOD',
  Pisc = 'PISC',
  Plafond = 'PLAFOND',
  Plan = 'PLAN',
  Pontroul = 'PONTROUL',
  Prox = 'PROX',
  Ran = 'RAN',
  Recp = 'RECP',
  Remi = 'REMI',
  Restau = 'RESTAU',
  Rue = 'RUE',
  Sal = 'SAL',
  Salle = 'SALLE',
  Sam = 'SAM',
  Sauna = 'SAUNA',
  Scommun = 'SCOMMUN',
  Sconf = 'SCONF',
  Sdb = 'SDB',
  Sdbccp = 'SDBCCP',
  Sdc = 'SDC',
  Sdj = 'SDJ',
  Sdl = 'SDL',
  Secretar = 'SECRETAR',
  Ser = 'SER',
  Sexerc = 'SEXERC',
  Sfm = 'SFM',
  Sol = 'SOL',
  Spa = 'SPA',
  Stat = 'STAT',
  Tboi = 'TBOI',
  Ter = 'TER',
  Tera = 'TERA',
  Vde = 'VDE',
  Veau = 'VEAU',
  Ver = 'VER',
  Vpla = 'VPLA',
  Vue = 'VUE',
  Walk = 'WALK'
}

export enum CtrVfCodeLangue {
  A = 'A',
  F = 'F'
}

export enum CtrVfCodeStatut {
  Ev = 'EV',
  Ve = 'VE'
}

export enum CtrVfCodeVisiteCaravane {
  Vl = 'VL',
  Vlv = 'VLV'
}

export enum CtrVfCouvrePlancherCode {
  Ardo = 'ARDO',
  Au = 'AU',
  Beto = 'BETO',
  Bois = 'BOIS',
  Ceram = 'CERAM',
  Csso = 'CSSO',
  Gran = 'GRAN',
  Lino = 'LINO',
  Marb = 'MARB',
  Parq = 'PARQ',
  Pflo = 'PFLO',
  Pvc = 'PVC',
  Tap = 'TAP',
  Tuile = 'TUILE'
}

export enum CtrVfEtage {
  Au = 'AU',
  Rc = 'RC',
  S2 = 'S2'
}

export enum CtrVfFrequenceDepense {
  A = 'A'
}

export enum CtrVfFrequencePrixLocation {
  A = 'A',
  M = 'M',
  S = 'S'
}

export enum CtrVfIndRepriseFinance {
  J = 'J',
  N = 'N',
  O = 'O'
}

export enum CtrVfIndVenteSansGarantieLegale {
  E = 'E',
  N = 'N',
  O = 'O'
}

export enum CtrVfNiveau {
  Au = 'AU',
  Dern = 'DERN',
  Ph = 'PH',
  Rc = 'RC',
  Rj = 'RJ',
  Te = 'TE'
}

export enum CtrVfPartDepense {
  Depgen = 'DEPGEN'
}

export enum CtrVfParticulariteConstruction {
  Cent = 'CENT',
  Conv = 'CONV',
  Hist = 'HIST',
  Neuve = 'NEUVE'
}

export enum CtrVfPieceCode {
  Ate = 'ATE',
  Au = 'AU',
  Bib = 'BIB',
  Bou = 'BOU',
  Bur = 'BUR',
  Cac = 'CAC',
  Cav = 'CAV',
  Ccp = 'CCP',
  Cr = 'CR',
  Cui = 'CUI',
  Hal = 'HAL',
  Mez = 'MEZ',
  Ran = 'RAN',
  Sal = 'SAL',
  Sam = 'SAM',
  Sdb = 'SDB',
  Sdc = 'SDC',
  Sdj = 'SDJ',
  Sdl = 'SDL',
  Ser = 'SER',
  Sfm = 'SFM',
  Sol = 'SOL',
  Ver = 'VER',
  Vin = 'VIN',
  Walk = 'WALK'
}

export enum CtrVfRenovationType {
  Autre = 'AUTRE',
  Chauf = 'CHAUF',
  Cui = 'CUI',
  Elec = 'ELEC',
  Fen = 'FEN',
  Planc = 'PLANC',
  Plomb = 'PLOMB',
  Sdb = 'SDB',
  Ss = 'SS',
  Toitr = 'TOITR'
}

export enum CtrVfTypeBatiment {
  Is = 'IS',
  Ju = 'JU',
  Quad = 'QUAD',
  Rg = 'RG'
}

export enum CtrVfTypeCertificatFirme {
  Acom = 'ACOM',
  Aich = 'AICH',
  Airc = 'AIRC',
  Airh = 'AIRH',
  Ares = 'ARES',
  Ca = 'CA',
  Ci = 'CI',
  Cia = 'CIA',
  Ciac = 'CIAC',
  Cic = 'CIC',
  Cicace = 'CICACE',
  Cicach = 'CICACH',
  Cicadace = 'CICADACE',
  Cicadach = 'CICADACH',
  Cicda = 'CICDA',
  Cich = 'CICH',
  Cih = 'CIH',
  Cir = 'CIR',
  Cirace = 'CIRACE',
  Cirach = 'CIRACH',
  Ciradace = 'CIRADACE',
  Ciradach = 'CIRADACH',
  Circ = 'CIRC',
  Circadace = 'CIRCADACE',
  Circadach = 'CIRCADACH',
  Circda = 'CIRCDA',
  Cirda = 'CIRDA',
  Cirh = 'CIRH',
  Cr = 'CR'
}

export enum CtrVfTypeCertificatMembre {
  Aa = 'AA',
  Af = 'AF',
  Ar = 'AR',
  Ccom = 'CCOM',
  Ciac = 'CIAC',
  Ciacda = 'CIACDA',
  Ciada = 'CIADA',
  Cicace = 'CICACE',
  Cicach = 'CICACH',
  Cicada = 'CICADA',
  Cicadach = 'CICADACH',
  Cicda = 'CICDA',
  Cich = 'CICH',
  Cichada = 'CICHADA',
  Cirace = 'CIRACE',
  Cirach = 'CIRACH',
  Cirachda = 'CIRACHDA',
  Cirada = 'CIRADA',
  Circ = 'CIRC',
  Circada = 'CIRCADA',
  Circda = 'CIRCDA',
  Cirda = 'CIRDA',
  Cirh = 'CIRH',
  Cirhada = 'CIRHADA',
  Cres = 'CRES'
}

export enum CtrVfTypeCopropriete {
  Div = 'DIV',
  Ind = 'IND'
}

export enum CtrVfTypeDepense {
  Admin = 'ADMIN',
  Asce = 'ASCE',
  Assu = 'ASSU',
  Aude = 'AUDE',
  Autd = 'AUTD',
  Cabl = 'CABL',
  Conc = 'CONC',
  Csan = 'CSAN',
  Dech = 'DECH',
  Ener = 'ENER',
  Entr = 'ENTR',
  Fcop = 'FCOP',
  Fraiscomm = 'FRAISCOMM',
  Franc = 'FRANC',
  Gazo = 'GAZO',
  Lautre = 'LAUTRE',
  Loyer = 'LOYER',
  Permis = 'PERMIS',
  Publ = 'PUBL',
  Recupdep = 'RECUPDEP',
  Sal = 'SAL',
  Secu = 'SECU',
  Sysal = 'SYSAL',
  Taxaff = 'TAXAFF',
  Taxaut = 'TAXAUT',
  Taxeau = 'TAXEAU',
  Taxmun = 'TAXMUN',
  Taxsco = 'TAXSCO',
  Taxsec = 'TAXSEC',
  Tele = 'TELE'
}

export enum CtrVfTypeDivulInteret {
  Dir = 'DIR',
  Ind = 'IND'
}

export enum CtrVfTypeLien {
  Vis3D = 'VIS3D',
  Visaer = 'VISAER',
  Visaut = 'VISAUT',
  Viscom = 'VISCOM',
  Visvid = 'VISVID'
}

export enum CtrVfTypeMediaSocial {
  Faceb = 'FACEB',
  Instag = 'INSTAG',
  Link = 'LINK',
  Twit = 'TWIT',
  Ytube = 'YTUBE'
}

export enum CtrVfTypeSuperficieHabitable {
  Brut = 'BRUT',
  Net = 'NET'
}

export enum CtrVfTypeUniteDet {
  Bur = 'BUR',
  Comm = 'COMM',
  Entr = 'ENTR',
  Inds = 'INDS',
  Intg = 'INTG',
  Logement = 'LOGEMENT',
  Principal = 'PRINCIPAL'
}

export enum CtrVfTypeUniteSom {
  Au = 'AU',
  Bur = 'BUR',
  Chambre = 'CHAMBRE',
  Comm = 'COMM',
  Entr = 'ENTR',
  Inds = 'INDS',
  Ls = 'LS'
}

export enum CtrVfUmAireBatiment {
  Mc = 'MC',
  Pc = 'PC'
}

export enum CtrVfUmDimensionBatiment {
  M = 'M',
  P = 'P'
}

export enum CtrVfUmDimensionTerrain {
  Ar = 'AR',
  M = 'M',
  P = 'P'
}

export enum CtrVfUmHauteurLibre {
  M = 'M',
  P = 'P'
}

export enum CtrVfUmLoyerMensuelUnitaire {
  Mc = 'MC',
  Pc = 'PC'
}

export enum CtrVfUmPrix {
  Ac = 'AC',
  Ar = 'AR',
  He = 'HE',
  Mc = 'MC',
  Pc = 'PC'
}

export enum CtrVfUmSuperficieTerrain {
  Ac = 'AC',
  Ar = 'AR',
  He = 'HE',
  Mc = 'MC',
  Pc = 'PC'
}

export enum CtrVfUmSuperficieTotale {
  Ac = 'AC',
  Ar = 'AR',
  He = 'HE',
  Mc = 'MC',
  Pc = 'PC'
}

export enum CtrVfUmSuperficieVacante {
  Mc = 'MC',
  Pc = 'PC'
}

export enum CtrVfUtilisationCommerciale {
  Bur = 'BUR',
  Comm = 'COMM',
  Commbur = 'COMMBUR'
}

export type CtrValeursFixes = {
  __typename?: 'CtrValeursFixes';
  CUSTOM_EN?: Maybe<Scalars['String']['output']>;
  CUSTOM_FR?: Maybe<Scalars['String']['output']>;
  /** Summarized English description */
  DESCRIPTION_ABREGEE_ANGLAISE?: Maybe<Scalars['String']['output']>;
  /** Summarized French description */
  DESCRIPTION_ABREGEE_FRANCAISE?: Maybe<Scalars['String']['output']>;
  /** English description */
  DESCRIPTION_ANGLAISE?: Maybe<Scalars['String']['output']>;
  /** French description */
  DESCRIPTION_FRANCAISE?: Maybe<Scalars['String']['output']>;
  /** Field code */
  DOMAINE?: Maybe<Scalars['String']['output']>;
  /** Value code */
  VALEUR?: Maybe<Scalars['String']['output']>;
};

export type CtrVisitesLibres = {
  __typename?: 'CtrVisitesLibres';
  /** Indicates if it is an open house (VL) or a virtual open house (VLV) */
  CODE_VISITE_CARAVANE?: Maybe<Scalars['String']['output']>;
  /** English comments */
  COMMENTAIRES_A?: Maybe<Scalars['String']['output']>;
  /** French comments */
  COMMENTAIRES_F?: Maybe<Scalars['String']['output']>;
  /** Open house start date (format YYYY/MM/DD) */
  DATE_DEBUT?: Maybe<Scalars['String']['output']>;
  /** Open house end date (format YYYY/MM/DD) */
  DATE_FIN?: Maybe<Scalars['String']['output']>;
  /** Open house start time (format HH:mm) */
  HEURE_DEBUT?: Maybe<Scalars['String']['output']>;
  /** Open house end time (format HH:mm) */
  HEURE_FIN?: Maybe<Scalars['String']['output']>;
  /** Virtual open house: Virtual open house URL */
  LIEN_VISITE_VIRT?: Maybe<Scalars['String']['output']>;
  /** Listing number */
  NO_INSCRIPTION?: Maybe<Scalars['String']['output']>;
  /** Open house number */
  SEQ?: Maybe<Scalars['String']['output']>;
};

/** Type of database entry */
export enum EntityType {
  Feed = 'FEED',
  Lead = 'LEAD',
  MatrixJob = 'MATRIX_JOB',
  User = 'USER'
}

/** Number of events per event type (e.g. show_interest, page_view, click_to_call, etc.) */
export type GaCountsPerEvent = {
  __typename?: 'GaCountsPerEvent';
  count?: Maybe<Scalars['Int']['output']>;
  event?: Maybe<Scalars['String']['output']>;
};

/** Google Analytics stats - combined stats per property (listing) */
export type GaPropertyStats = {
  __typename?: 'GaPropertyStats';
  cities?: Maybe<Array<Maybe<GaViewsPerCity>>>;
  events?: Maybe<Array<Maybe<GaCountsPerEvent>>>;
  sources?: Maybe<Array<Maybe<GaViewsPerSource>>>;
  totalViews?: Maybe<Scalars['Int']['output']>;
};

/** Google Analytics stats - views / city */
export type GaViewsPerCity = {
  __typename?: 'GaViewsPerCity';
  city?: Maybe<Scalars['String']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
};

/** Google Analytics stats - views / source */
export type GaViewsPerSource = {
  __typename?: 'GaViewsPerSource';
  sessions?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

/** manual reproduction of official GeoJSON.Point (@types/geojson) */
export type GeoJson_Point = {
  __typename?: 'GeoJSON_Point';
  coordinates?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  type?: Maybe<Scalars['String']['output']>;
};

/** Generic interface representing the basic properties of any 'collection' entry (used in TS generics, etc.) */
export type ICollection = {
  active?: Maybe<Scalars['Boolean']['output']>;
  created?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  updated?: Maybe<Scalars['String']['output']>;
};

export type ICollectionInput = {
  entry?: Maybe<ICollection>;
};

/** Prefixes for different types of IDs */
export enum IdPrefixes {
  /** centris feed */
  Feed = 'feed',
  /** new contact lead */
  Lead = 'lead',
  /** matrix job */
  Mjob = 'mjob',
  /** user */
  Usr = 'usr'
}

/** McGill-specific project (used to properly differentiate broker's EV vs McGill listings) */
export type McGillProject = {
  __typename?: 'McGillProject';
  addresses?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['String']['output']>;
  wp_id?: Maybe<Scalars['String']['output']>;
};

export type McGillProjectInput = {
  addresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['String']['input']>;
  wp_id?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  deleteUser?: Maybe<Scalars['Boolean']['output']>;
  /** take username / password, check for user, and return it if found */
  login?: Maybe<XUser>;
  /** authenticate user for broker portal */
  loginToBrokerPortal?: Maybe<Scalars['Boolean']['output']>;
  /** just clear auth-related cookies and return the timestamp of logout */
  logout?: Maybe<Scalars['String']['output']>;
  /** Generic method to set/update a config option */
  setConfigOption?: Maybe<Scalars['Boolean']['output']>;
  test?: Maybe<Scalars['String']['output']>;
  /** update mapping for single broker to his/her site used for listing redirection */
  updateBrokerRedirect?: Maybe<BrokerRedirect>;
  /** override any value in dynamic tables; the new values are stored in override_<table> collection */
  updateCtrDynamicTable?: Maybe<Scalars['Boolean']['output']>;
  /** update 'label_fr' OR 'label_en' for given table + field name combination (not an upsert; field must exist) */
  updateCtrMetaField?: Maybe<Scalars['Boolean']['output']>;
  /** set custom en/fr label for one entry in any static table (generic for all static tables) */
  updateCtrStaticTable?: Maybe<Scalars['Boolean']['output']>;
  /** update single React text */
  updateReactText?: Maybe<ReactText>;
  /** update a specific website's config */
  updateWebsiteConfig?: Maybe<WebsiteConfig>;
  upsertUser?: Maybe<XUser>;
};


export type MutationDeleteUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLoginArgs = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationLoginToBrokerPortalArgs = {
  password: Scalars['String']['input'];
};


export type MutationSetConfigOptionArgs = {
  key: XConfigKeys;
  value: Scalars['String']['input'];
};


export type MutationUpdateBrokerRedirectArgs = {
  redir: BrokerRedirectInput;
};


export type MutationUpdateCtrDynamicTableArgs = {
  entry: CtrDynamicCustomInput;
};


export type MutationUpdateCtrMetaFieldArgs = {
  entry: CtrMetaFieldInput;
};


export type MutationUpdateCtrStaticTableArgs = {
  entry: CtrStaticCustomInput;
};


export type MutationUpdateReactTextArgs = {
  text: ReactTextInput;
};


export type MutationUpdateWebsiteConfigArgs = {
  cfg: WebsiteConfigInput;
};


export type MutationUpsertUserArgs = {
  entry: XUserInput;
};

/** GENRES_PROPRIETES: custom ordering of genres done via admin drag-&-drop interface (includes 'home' & 'plex') */
export type OrderedPropertyType = {
  __typename?: 'OrderedPropertyType';
  /** always match w/ TypeOption.key in frontend React - either a single genre or a grouping of genres */
  key?: Maybe<Scalars['String']['output']>;
  /** user-friendly translatable label to display in the filter */
  label?: Maybe<Scalars['String']['output']>;
  /** order in which to display this property type single/group in the grid-view filter */
  order?: Maybe<Scalars['Int']['output']>;
  /** either single array-bound genre's code or array of multiple genre codes to be grouped under that label */
  value?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type OrderedPropertyTypeInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** ES search hit for a single property */
export type PropertyHit = {
  __typename?: 'PropertyHit';
  mls_id?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

export type Query = {
  __typename?: 'Query';
  authenticated?: Maybe<AuthResponse>;
  /** whether broker is still authenticated to broker portal */
  authenticatedBrokerPortal?: Maybe<Scalars['Boolean']['output']>;
  /** whether specific listing's seller report is authorized to be printed */
  authenticatedSellerReport?: Maybe<Scalars['Boolean']['output']>;
  /** each broker ID is mapped to his site (main domain) - used to dynamically build 'mls_redirects' collection */
  brokerRedirects?: Maybe<Array<Maybe<BrokerRedirect>>>;
  ctrAddenda?: Maybe<Array<Maybe<CtrAddenda>>>;
  ctrBureaux?: Maybe<Array<Maybe<CtrBureaux>>>;
  ctrCaracteristiques?: Maybe<Array<Maybe<CtrCaracteristiques>>>;
  ctrDepenses?: Maybe<Array<Maybe<CtrDepenses>>>;
  /** for each dynamic table name, return an array of columns that make up the unique key for each entry */
  ctrDynamicUniqueKeys?: Maybe<CtrDynamicUniqueKeys>;
  ctrFirmes?: Maybe<Array<Maybe<CtrFirmes>>>;
  ctrGenresProprietes?: Maybe<Array<Maybe<CtrGenresProprietes>>>;
  ctrInscription?: Maybe<CtrInscriptions>;
  /** get all listings (full details) -- optionally filter by broker ID or office ID */
  ctrInscriptions?: Maybe<Array<Maybe<CtrInscriptions>>>;
  ctrLiensAdditionnels?: Maybe<Array<Maybe<CtrLiensAdditionnels>>>;
  ctrMembres?: Maybe<Array<Maybe<CtrMembres>>>;
  ctrMembresMediasSociaux?: Maybe<Array<Maybe<CtrMembresMediasSociaux>>>;
  ctrMetaFields?: Maybe<Array<Maybe<CtrMetaField>>>;
  ctrMetaTables?: Maybe<Array<Maybe<CtrMetaTable>>>;
  ctrMunicipalites?: Maybe<Array<Maybe<CtrMunicipalites>>>;
  ctrPhotos?: Maybe<Array<Maybe<CtrPhotos>>>;
  ctrPiecesUnites?: Maybe<Array<Maybe<CtrPiecesUnites>>>;
  ctrQuartiers?: Maybe<Array<Maybe<CtrQuartiers>>>;
  ctrRegions?: Maybe<Array<Maybe<CtrRegions>>>;
  ctrRemarques?: Maybe<Array<Maybe<CtrRemarques>>>;
  ctrRenovations?: Maybe<Array<Maybe<CtrRenovations>>>;
  /** fetch specific characteristic types for all listings - use in grid listing to display icons (e.g. garages) */
  ctrSomeCaracteristiques?: Maybe<Array<Maybe<CtrCaracteristiques>>>;
  ctrSousTypesCaracteristiques?: Maybe<Array<Maybe<CtrSousTypeCaracteristiques>>>;
  /** for each static table name, return an array of columns that make up the unique key for each entry */
  ctrStaticUniqueKeys?: Maybe<CtrStaticUniqueKeys>;
  /** fetch all thumbnail photos (seq=1) -- then use JS in frontend to get photo for each MLS ID */
  ctrThumbnails?: Maybe<Array<Maybe<CtrPhotos>>>;
  ctrTypesBannieres?: Maybe<Array<Maybe<CtrTypesBannieres>>>;
  ctrTypesCaracteristiques?: Maybe<Array<Maybe<CtrTypeCaracteristiques>>>;
  ctrUnitesDetaillees?: Maybe<Array<Maybe<CtrUnitesDetaillees>>>;
  ctrUnitesSommaires?: Maybe<Array<Maybe<CtrUnitesSommaires>>>;
  ctrValeursFixes?: Maybe<Array<Maybe<CtrValeursFixes>>>;
  ctrVisitesLibres?: Maybe<Array<Maybe<CtrVisitesLibres>>>;
  /** query Google Analytics stats for specific property */
  googleAnalyticsStats?: Maybe<GaPropertyStats>;
  /** Given the type, generate a unique nanoid prefixed w/ the type acronym */
  id?: Maybe<Scalars['String']['output']>;
  /** Use in Kotlin app for easy enum access to prefixes per id type */
  idPrefixes?: Maybe<IdPrefixes>;
  /** For the specified entity type and an arbitrary number (X), generate X unique IDs */
  ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** try to get McGill project associated with MLS ID by address (null if none found) */
  mcgillProject?: Maybe<Scalars['String']['output']>;
  /** fetch custom React frontend texts */
  reactTexts?: Maybe<Array<Maybe<ReactText>>>;
  /** given search term, search properties via ElasticSearch API */
  searchProperties?: Maybe<Array<Maybe<PropertyHit>>>;
  testQuery?: Maybe<Scalars['String']['output']>;
  user?: Maybe<XUser>;
  users?: Maybe<Array<Maybe<XUser>>>;
  /** given 'origin' passed in request headers, return specific config (e.g. brokers, offices, etc.) */
  websiteConfig?: Maybe<WebsiteConfig>;
};


export type QueryAuthenticatedSellerReportArgs = {
  token: Scalars['String']['input'];
};


export type QueryCtrAddendaArgs = {
  mlsId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCtrCaracteristiquesArgs = {
  mlsId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCtrDepensesArgs = {
  mlsId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCtrInscriptionArgs = {
  mlsId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCtrInscriptionsArgs = {
  broker?: InputMaybe<Scalars['String']['input']>;
  office?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCtrLiensAdditionnelsArgs = {
  mlsId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCtrMunicipalitesArgs = {
  codes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCtrPhotosArgs = {
  mlsId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCtrPiecesUnitesArgs = {
  mlsId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCtrQuartiersArgs = {
  munCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCtrRemarquesArgs = {
  mlsId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCtrRenovationsArgs = {
  mlsId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCtrSomeCaracteristiquesArgs = {
  mlsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCtrThumbnailsArgs = {
  mlsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryCtrUnitesDetailleesArgs = {
  mlsId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCtrUnitesSommairesArgs = {
  mlsId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCtrVisitesLibresArgs = {
  mlsId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGoogleAnalyticsStatsArgs = {
  end?: InputMaybe<Scalars['String']['input']>;
  mls: Scalars['String']['input'];
  start?: InputMaybe<Scalars['String']['input']>;
};


export type QueryIdArgs = {
  type?: InputMaybe<EntityType>;
};


export type QueryIdsArgs = {
  count: Scalars['Int']['input'];
  type?: InputMaybe<EntityType>;
};


export type QueryMcgillProjectArgs = {
  mls: Scalars['String']['input'];
};


export type QuerySearchPropertiesArgs = {
  term?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Custom texts embedded in React frontend code */
export type ReactText = {
  __typename?: 'ReactText';
  custom_en?: Maybe<Scalars['String']['output']>;
  custom_fr?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  original?: Maybe<Scalars['String']['output']>;
};

/** Custom texts embedded in React frontend code */
export type ReactTextInput = {
  custom_en?: InputMaybe<Scalars['String']['input']>;
  custom_fr?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  original?: InputMaybe<Scalars['String']['input']>;
};

export type SearchableCity = {
  __typename?: 'SearchableCity';
  city_code?: Maybe<Scalars['String']['output']>;
  city_name?: Maybe<Scalars['String']['output']>;
  city_region?: Maybe<Scalars['String']['output']>;
};

/**
 * JSON structure containing all data about a single listing in a searchable format by search engine (ElasticSearch).
 * The data must be textual as the user could search for them and in both languages where relevant.
 */
export type SearchableListing = {
  __typename?: 'SearchableListing';
  address_en: Scalars['String']['output'];
  address_fr: Scalars['String']['output'];
  borough_en: Scalars['String']['output'];
  borough_fr: Scalars['String']['output'];
  city_en: Scalars['String']['output'];
  city_fr: Scalars['String']['output'];
  location: GeoJson_Point;
  mls_id: Scalars['String']['output'];
  region_en: Scalars['String']['output'];
  region_fr: Scalars['String']['output'];
  title_en: Scalars['String']['output'];
  title_fr: Scalars['String']['output'];
  /** search-only apartment/unit variants used by Elasticsearch; not intended for display */
  unit_search?: Maybe<Scalars['String']['output']>;
};

export type SearchableRegion = {
  __typename?: 'SearchableRegion';
  region_code?: Maybe<Scalars['String']['output']>;
  region_name?: Maybe<Scalars['String']['output']>;
};

export enum UserRole {
  Admin = 'ADMIN',
  SuperAdmin = 'SUPER_ADMIN',
  User = 'USER'
}

/** per-website broker/office configuration */
export type WebsiteConfig = {
  __typename?: 'WebsiteConfig';
  /** password-like code for broker to access his broker portal */
  access_code?: Maybe<Scalars['String']['output']>;
  /** temporary cookie-like token (e.g. JWT) for controlling authorization of actions done in broker portal */
  access_token?: Maybe<Scalars['String']['output']>;
  /** list of specific brokers whose properties we are authorized to show */
  brokers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** default sorting for listings in grid view (desc price, asc price, desc updated, asc updated) */
  default_grid_sort?: Maybe<Scalars['Int']['output']>;
  /** 'Origin' domain provided with each HTTP request coming from this website (used as unique identifier) */
  domain?: Maybe<Scalars['String']['output']>;
  /** whether to ONLY show EV brokers per listing and NEVER show any non-EV broker (e.g. TheAgency, Remax) */
  ev_only?: Maybe<Scalars['Boolean']['output']>;
  /** list of excluded municipalities so properties in those muns do not show up in the site */
  excluded_muns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** whether this site belongs to McGill or EV - used to apply different properties filters */
  is_mcgill?: Maybe<Scalars['Boolean']['output']>;
  /** SEO indexing policy for listing detail pages and property sitemap inclusion */
  listing_index_policy?: Maybe<WebsiteListingIndexPolicy>;
  /** whether to open listing in new tab (_blank) or current tab (_self) */
  listing_target_self?: Maybe<Scalars['Boolean']['output']>;
  /** list of offices whose properties we are authorized to show (used in combination w/ 'brokers') */
  offices?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** list of property types to include per domain/site (affects which properties are returned via API) */
  property_types?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** global ordering of all property types for display in grid view genre filter (unrelated to 'property_types') */
  ptype_ordering?: Maybe<Array<Maybe<OrderedPropertyType>>>;
  /** list of offices with restrictions (e.g. cannot show brokers) */
  restricted_offices?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** per-website broker/office configuration */
export type WebsiteConfigInput = {
  brokers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  default_grid_sort?: InputMaybe<Scalars['Int']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  ev_only?: InputMaybe<Scalars['Boolean']['input']>;
  excluded_muns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  is_mcgill?: InputMaybe<Scalars['Boolean']['input']>;
  listing_index_policy?: InputMaybe<WebsiteListingIndexPolicy>;
  listing_target_self?: InputMaybe<Scalars['Boolean']['input']>;
  offices?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  property_types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** though set per site, it is global and identical for all sites - just easier to have it there */
  ptype_ordering?: InputMaybe<Array<InputMaybe<OrderedPropertyTypeInput>>>;
  restricted_offices?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Controls which displayed listings are allowed to be indexed by search engines */
export enum WebsiteListingIndexPolicy {
  /** Index only listings where one of this site's configured brokers is listed on the property */
  BrokersOnly = 'BROKERS_ONLY',
  /** Index every listing allowed by this site's display filters, except restricted-office listings */
  DisplayedListings = 'DISPLAYED_LISTINGS',
  /** Display listings but noindex every listing detail page and omit listings from the sitemap */
  NoindexAll = 'NOINDEX_ALL'
}

/** List of possible config option keys in collection 'config' */
export enum XConfigKeys {
  DefaultLang = 'default_lang',
  DefaultPage = 'default_page'
}

export type XUser = {
  __typename?: 'XUser';
  active?: Maybe<Scalars['Boolean']['output']>;
  created?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  fname?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lname?: Maybe<Scalars['String']['output']>;
  role?: Maybe<UserRole>;
  updated?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type XUserInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  fname?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lname?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRole>;
  updated?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};


      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "ICollection": [],
    "ICollectionInput": []
  }
};
      export default result;
    